/* eslint-disable max-len */
export const translations = {
  en: {
    // Navigation
    home: 'Home',
    user: 'User',
    users: 'Users',
    customers: 'Customers',
    definitions: 'Definitions',
    orderStatus: 'Order Status',
    stockStatus: 'Stock Status',
    shipmentStatus: 'Shipment Status',
    material: 'Material',
    yarn: 'Yarn',
    thread: 'Thread',
    weave: 'Weave',
    weaveInformation: 'Weave Information',
    color: 'Color',
    unit: 'Unit',
    composition: 'Composition',
    weaveColor: 'Weave Color',
    currency: 'Currency',
    weaveType: 'Weave Type',
    copyUserId: 'Copy User ID',
    copied: 'Copied',
    Optional: 'Optional',
    allStatuses: 'All',
    all: 'All',
    clear: 'Clear',
    userGuide: 'User Guide',
    // Theme
    light: 'Light',
    dark: 'Dark',
    auto: 'Auto',
    success: 'Success',

    // Common actions
    save: 'Save',
    cancel: 'Cancel',
    copyWeave: 'Copy',
    newWeaveCode: 'New weave code',
    enterNewWeaveCode: 'Enter new weave code',
    copyWeaveCodeRequired: 'New weave code is required.',
    copyWeaveNotFound: 'Weave to copy was not found.',
    copyWeaveError: 'An error occurred while copying.',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    confirm: 'Confirm',
    back: 'Back',
    copy:'Copy',

    // Status
    active: 'Active',
    inactive: 'Inactive',
    loading: 'Loading...',
    saving: 'Saving...',
    creating: 'Creating...',
    updating: 'Updating...',
    deleting: 'Deleting...',

    // Language
    language: 'Language',
    english: 'English',
    turkish: 'Turkish',

    // Table Headers
    'Status ID': 'Status ID',
    'Status Name': 'Status Name',
    'Description': 'Description',
    'Actions': 'Actions',
    'Show': 'Show',
    'entries': 'entries',
    'Showing': 'Showing',
    'to': 'to',
    'of': 'of',
    'Previous': 'Previous',
    'Next': 'Next',
    noDataFound: 'No data found.',
    loadingData: 'Loading data...',
    anErrorOccurred: 'An error occurred',
    noDataAvailable: 'No data available',

    // Order Status
    createNewOrder: 'Create New Order',
    editOrderStatus: 'Edit Order Status',
    deleteOrderStatus: 'Delete Order Status',
    updateOrderStatus: 'Update Order Status',
    createOrderStatus: 'Create Order Status',
    orderStatusName: 'Order Status Name',
    orderStatusDescription: 'Order Status Description',
    enterOrderStatusName: 'Enter order status name',
    enterOrderStatusDescription: 'Enter order status description',
    orderStatusNameRequired: 'Order status name is required',
    orderStatusDescriptionRequired: 'Order status description is required',
    orderStatusCreated: 'Order status created successfully',
    orderStatusUpdated: 'Order status updated successfully',
    orderStatusDeleted: 'Order status deleted successfully',
    confirmDeleteOrderStatus: 'Are you sure you want to delete this order status?',
    thisActionCannotBeUndone: 'This action cannot be undone.',
    orders: 'Orders',
    order: 'Order',
    createOrder: 'Create Order',
    updateOrder: 'Update Order',
    deleteOrder: 'Delete Order',
    editOrder: 'Edit Order',
    orderCreated: 'Order created successfully',
    orderUpdated: 'Order updated successfully',
    orderDeleted: 'Order deleted successfully',
    confirmDeleteOrder: 'Are you sure you want to delete this order?',
    orderDeleteWarning: 'This action will permanently delete the order and cannot be undone.',
    orderGuid: 'Order Guid',
    previous: 'Previous',
    next: 'Next',
    prdProductGuid: 'Product Guid',
    opsCustomerGuid: 'Customer Guid',
    opsSupplierGuid: 'Supplier Guid',
    prdUnitGuid: 'Unit Guid',
    prdUnit: 'Unit',
    prdCurrencyGuid: 'Currency Guid',
    opsOrderStatusGuid: 'Order Status Guid',
    orderDatetime: 'Order Datetime',
    orderDeadlineDatetime: 'Order Deadline',
    productQuantity: 'Product Quantity',
    productionStartDatetime: 'Production Start',
    productionEndDatetime: 'Production End',
    productDispatchQuantity: 'Dispatch Quantity',
    productStockQuantity: 'Stock Quantity',
    productRemainingQuantity: 'Remaining Quantity',
    productCostPrice: 'Cost Price',
    productSalesPrice: 'Sales Price',
    productTotalPrice: 'Total Price',
    orderDescription: 'Order Description',
    orderDescriptionPlaceholder: 'Enter order description',
    note: 'Note',
    notePlaceholder: 'Enter note',
    productCodeForCustomer: 'Product Code',
    customerName: 'Customer Name',
    supplierName: 'Supplier Name',
    insertUserGuid: 'Insert User Guid',
    insertDatetime: 'Insert Datetime',

    // Stock Status
    createNewStock: 'Create New Stock Status',
    editStockStatus: 'Edit Stock Status',
    deleteStockStatus: 'Delete Stock Status',
    updateStockStatus: 'Update Stock Status',
    createStockStatus: 'Create Stock Status',
    stockStatusName: 'Stock Status Name',
    stockStatusDescription: 'Stock Status Description',
    enterStockStatusName: 'Enter stock status name',
    enterStockStatusDescription: 'Enter stock status description',
    stockStatusNameRequired: 'Stock status name is required',
    stockStatusDescriptionRequired: 'Stock status description is required',
    stockStatusCreated: 'Stock status created successfully',
    stockStatusUpdated: 'Stock status updated successfully',
    stockStatusDeleted: 'Stock status deleted successfully',

    // Shipment Status
    'Shipment Status': 'Shipment Status',
    'shipmentStatusName': 'Shipment Status Name',
    'shipmentStatusDescription': 'Shipment Status Description',
    'enterShipmentStatusName': 'Enter Shipment Status Name',
    'enterShipmentStatusDescription': 'Enter Shipment Status Description',
    'shipmentStatusNameRequired': 'Shipment Status Name is required',
    'shipmentStatusDescriptionRequired': 'Shipment Status Description is required',
    'shipmentStatusCreated': 'Shipment Status created successfully',
    'shipmentStatusUpdated': 'Shipment Status updated successfully',
    'shipmentStatusDeleted': 'Shipment Status deleted successfully',
    'createShipmentStatus': 'Create Shipment Status',
    'updateShipmentStatus': 'Update Shipment Status',
    'deleteShipmentStatus': 'Delete Shipment Status',
    'confirmDeleteShipmentStatus': 'Are you sure you want to delete this shipment status?',

    // Error Messages
    somethingWentWrong: 'Something went wrong',
    sessionExpired: 'Session expired. Please login again.',
    userSessionNotFound: 'User session not found. Please login again.',
    pageNotFound: 'Page not found',

    // Breadcrumbs
    backToOrders: 'Back to Orders',
    backToStock: 'Back to Stock',
    backToShipment: 'Back to Shipment',

    // Table Common
    showing: 'Showing',
    to: 'to',
    of: 'of',
    id: 'ID',
    orderNo: 'Order No',
    generatingOrderNo: 'Generating Order No...',
    name: 'Name',
    editItem: 'Edit',
    deleteItem: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete this item?',

    // Common Form Labels
    nameRequired: 'Name is required',
    descriptionRequired: 'Description is required',
    enterName: 'Enter name',
    enterDescription: 'Enter description',

    // Status Messages
    itemCreated: 'Item created successfully',
    itemUpdated: 'Item updated successfully',
    itemDeleted: 'Item deleted successfully',

    // Material
    materials: 'Materials',
    createMaterial: 'Create Material',
    updateMaterial: 'Update Material',
    materialName: 'Material Name',
    materialProperties: 'Material Properties',
    materialDescription: 'Material Description',
    enterMaterialName: 'Enter material name',
    enterMaterialDescription: 'Enter material description',
    materialNameRequired: 'Material name is required',
    materialDescriptionRequired: 'Material description is required',
    materialCreated: 'Material created successfully',
    materialUpdated: 'Material updated successfully',
    materialDeleted: 'Material deleted successfully',

    // Yarn
    yarns: 'Yarns',
    createYarn: 'Create Yarn',
    updateYarn: 'Update Yarn',
    yarnCode: 'Yarn Code',
    yarnName: 'Yarn Name',
    yarnType: 'Yarn Type',
    yarnTypeNe: 'Ne (English Number)',
    yarnTypeNm: 'Nm (Metric Number)',
    yarnTypeDny: 'Dny (Denier)',
    yarnTypeNeDesc: 'For cotton-tencel-viscose yarns (4/1ne, 120/1ne)',
    yarnTypeNmDesc: 'For linen yarns (13 nm, 39 nm)',
    yarnTypeDnyDesc: 'For polyester-nylon yarns (150/288/40, 40/34/20)',
    sampleFormats: 'Sample Formats',
    sampleFormatNe: '8/1 (for Ne)',
    sampleFormatNm: '13 nm (for Nm)',
    sampleFormatDny: '150/288/40 (for Dny)',
    yarnFactor: 'Yarn Factor',
    yarnDescription: 'Yarn Description',
    enterYarnCode: 'Enter yarn code',
    enterYarnName: 'Enter yarn name',
    selectYarnType: 'Select yarn type',
    enterYarnDescription: 'Enter yarn description',
    yarnCodeRequired: 'Yarn code is required',
    yarnNameRequired: 'Yarn name is required',
    yarnTypeRequired: 'Yarn type is required',
    yarnDescriptionRequired: 'Yarn description is required',
    yarnCreated: 'Yarn created successfully',
    yarnUpdated: 'Yarn updated successfully',
    yarnDeleted: 'Yarn deleted successfully',
    deleteYarn: 'Delete Yarn',
    confirmDeleteYarn: 'Are you sure you want to delete this yarn?',
    createNewYarn: 'Create New Yarn',
    stockStartDate: 'Stock Start Date',
    stockEndDate: 'Stock End Date',

    // Thread
    threadType: 'Thread Type',
    threadCount: 'Thread Count',
    specification: 'Specification',
    threads: 'Threads',
    createThread: 'Create Thread',
    updateThread: 'Update Thread',
    threadName: 'Thread Name',
    threadDescription: 'Thread Description',
    enterThreadName: 'Enter thread name',
    enterThreadDescription: 'Enter thread description',
    threadNameRequired: 'Thread name is required',
    threadDescriptionRequired: 'Thread description is required',
    threadCreated: 'Thread created successfully',
    threadUpdated: 'Thread updated successfully',
    threadDeleted: 'Thread deleted successfully',

    // Weave
    weaves: 'Weaves',
    createWeave: 'Create Weave',
    updateWeave: 'Update Weave',
    weaveName: 'Weave Name',
    weaveDescription: 'Weave Description',
    enterWeaveName: 'Enter weave name',
    enterWeaveDescription: 'Enter weave description',
    weaveNameRequired: 'Weave name is required',
    weaveDescriptionRequired: 'Weave description is required',
    weaveCreated: 'Weave created successfully',
    weaveUpdated: 'Weave updated successfully',
    weaveDeleted: 'Weave deleted successfully',

    // Color
    colors: 'Colors',
    createColor: 'Create Color',
    updateColor: 'Update Color',
    colorName: 'Color Name',
    colorCode: 'Color Code',
    colorDescription: 'Color Description',
    enterColorName: 'Enter color name',
    enterColorCode: 'Enter color code',
    enterColorDescription: 'Enter color description',
    colorNameRequired: 'Color name is required',
    colorCodeRequired: 'Color code is required',
    colorDescriptionRequired: 'Color description is required',
    colorCreated: 'Color created successfully',
    colorUpdated: 'Color updated successfully',
    colorDeleted: 'Color deleted successfully',

    // Unit
    units: 'Units',
    createUnit: 'Create Unit',
    updateUnit: 'Update Unit',
    unitName: 'Unit Name',
    unitDescription: 'Unit Description',
    enterUnitName: 'Enter unit name',
    enterUnitDescription: 'Enter unit description',
    unitNameRequired: 'Unit name is required',
    unitDescriptionRequired: 'Unit description is required',
    unitCreated: 'Unit created successfully',
    unitUpdated: 'Unit updated successfully',
    unitDeleted: 'Unit deleted successfully',

    // Composition
    compositions: 'Compositions',
    createComposition: 'Create Composition',
    updateComposition: 'Update Composition',
    deleteComposition: 'Delete Composition',
    compositionName: 'Composition Name',
    compositionDescription: 'Composition Description',
    enterCompositionName: 'Enter composition name',
    enterCompositionDescription: 'Enter composition description',
    compositionNameRequired: 'Composition name is required',
    compositionDescriptionRequired: 'Composition description is required',
    compositionCreated: 'Composition created successfully',
    compositionUpdated: 'Composition updated successfully',
    compositionDeleted: 'Composition deleted successfully',
    // Composition specific translations for weaving thread
    threadName: 'Weaving Thread Name',
    threadDescription: 'Weaving Thread Description',
    enterThreadName: 'Enter weaving thread name',
    enterThreadDescription: 'Enter weaving thread description',
    threadCompositionDescription: 'Mixture description',
    enterThreadCompositionDescription: 'Enter mixture description',
    threadNameRequired: 'Weaving thread name is required',
    threadDescriptionRequired: 'Weaving thread description is required',
    confirmDeleteComposition: 'Are you sure you want to delete this composition?',
    confirmDeleteCompositionStatus: 'Are you sure you want to delete this composition?',

    // Weave Color
    weaveColors: 'Weave Colors',
    createWeaveColor: 'Create Weave Color',
    updateWeaveColor: 'Update Weave Color',
    weaveColorName: 'Weave Color Name',
    weaveColorDescription: 'Weave Color Description',
    enterWeaveColorName: 'Enter weave color name',
    enterWeaveColorDescription: 'Enter weave color description',
    weaveColorNameRequired: 'Weave color name is required',
    weaveColorDescriptionRequired: 'Weave color description is required',
    weaveColorCreated: 'Weave color created successfully',
    weaveColorUpdated: 'Weave color updated successfully',
    weaveColorDeleted: 'Weave color deleted successfully',

    // Currency
    currencies: 'Currencies',
    createCurrency: 'Create Currency',
    updateCurrency: 'Update Currency',
    currencyName: 'Currency Name',
    currencyDescription: 'Currency Description',
    enterCurrencyName: 'Enter currency name',
    enterCurrencyDescription: 'Enter currency description',
    currencyNameRequired: 'Currency name is required',
    currencyDescriptionRequired: 'Currency description is required',
    currencyCreated: 'Currency created successfully',
    currencyUpdated: 'Currency updated successfully',
    currencyDeleted: 'Currency deleted successfully',

    // Weave Type
    weaveTypes: 'Weave Types',
    createWeaveType: 'Create Weave Type',
    updateWeaveType: 'Update Weave Type',
    weaveTypeName: 'Weave Type Name',
    weaveTypeDescription: 'Weave Type Description',
    enterWeaveTypeName: 'Enter weave type name',
    enterWeaveTypeDescription: 'Enter weave type description',
    weaveTypeNameRequired: 'Weave type name is required',
    weaveTypeDescriptionRequired: 'Weave type description is required',
    weaveTypeCreated: 'Weave type created successfully',
    weaveTypeUpdated: 'Weave type updated successfully',
    weaveTypeDeleted: 'Weave type deleted successfully',

    // Supplier Type
    supplierTypes: 'Supplier Types',
    supplierType: 'Supplier Type',
    createSupplierType: 'Create Supplier Type',
    updateSupplierType: 'Update Supplier Type',
    supplierTypeName: 'Supplier Type Name',
    supplierTypeDescription: 'Supplier Type Description',
    enterSupplierTypeName: 'Enter supplier type name',
    enterSupplierTypeDescription: 'Enter supplier type description',
    supplierTypeNameRequired: 'Supplier type name is required',
    supplierTypeDescriptionRequired: 'Supplier type description is required',
    supplierTypeCreated: 'Supplier type created successfully',
    supplierTypeUpdated: 'Supplier type updated successfully',
    supplierTypeDeleted: 'Supplier type deleted successfully',

    // Pagination
    paginationInfo: 'Showing {{start}} to {{end}} of {{total}} entries',

    // Stock
    'Stock Status': 'Stock Status',
    'Create New Stock': 'Create New Stock Status',
    'Stock List': 'Stock List',
    'Stock Details': 'Stock Details',
    'Stock Information': 'Stock Information',
    'Stock Code': 'Stock Code',
    'Stock Name': 'Stock Name',
    'Stock Type': 'Stock Type',
    'Stock Quantity': 'Stock Quantity',
    'Stock Unit': 'Stock Unit',
    'Stock Location': 'Stock Location',
    'Stock Notes': 'Stock Notes',
    'Enter Stock Code': 'Enter Stock Code',
    'Enter Stock Name': 'Enter Stock Name',
    'Enter Stock Type': 'Enter Stock Type',
    'Enter Stock Quantity': 'Enter Stock Quantity',
    'Enter Stock Location': 'Enter Stock Location',
    'Enter Stock Notes': 'Enter Stock Notes',
    'Stock Code Required': 'Stock Code is required',
    'Stock Name Required': 'Stock Name is required',
    'Stock Type Required': 'Stock Type is required',
    'Stock Quantity Required': 'Stock Quantity is required',
    'Stock Unit Required': 'Stock Unit is required',
    'Stock Location Required': 'Stock Location is required',

    // Shipment
    'Shipment List': 'Shipment List',
    'Shipment Details': 'Shipment Details',
    'Shipment Information': 'Shipment Information',
    'Shipment Code': 'Shipment Code',
    'Shipment Date': 'Shipment Date',
    'Shipment Type': 'Shipment Type',
    'Shipment Method': 'Shipment Method',
    'Shipment Carrier': 'Shipment Carrier',
    'Tracking Number': 'Tracking Number',
    'Shipment Notes': 'Shipment Notes',
    'Enter Shipment Code': 'Enter Shipment Code',
    'Enter Tracking Number': 'Enter Tracking Number',
    'Enter Shipment Notes': 'Enter Shipment Notes',
    'Select Shipment Date': 'Select Shipment Date',
    'Select Shipment Type': 'Select Shipment Type',
    'Select Shipment Method': 'Select Shipment Method',
    'Select Shipment Carrier': 'Select Shipment Carrier',
    'Shipment Code Required': 'Shipment Code is required',
    'Shipment Date Required': 'Shipment Date is required',
    'Shipment Type Required': 'Shipment Type is required',
    'Shipment Method Required': 'Shipment Method is required',
    'Shipment Carrier Required': 'Shipment Carrier is required',
    'Tracking Number Required': 'Tracking Number is required',

    // Additional Material translations
    'Material List': 'Material List',
    'Material Details': 'Material Details',
    'Material Information': 'Material Information',
    'Material Code': 'Material Code',
    'Material Type': 'Material Type',
    'Material Properties': 'Material Properties',
    'Material Supplier': 'Material Supplier',
    'Enter Material Code': 'Enter Material Code',
    'Enter Material Type': 'Enter Material Type',
    'Enter Material Properties': 'Enter Material Properties',
    'Select Material Supplier': 'Select Material Supplier',
    'Material Code Required': 'Material Code is required',
    'Material Type Required': 'Material Type is required',
    'Material Properties Required': 'Material Properties is required',
    'Material Supplier Required': 'Material Supplier is required',

    // Additional Yarn translations
    'Yarn List': 'Yarn List',
    'Yarn Details': 'Yarn Details',
    'Yarn Information': 'Yarn Information',
    'Yarn Code': 'Yarn Code',
    'Yarn Type': 'Yarn Type',
    'Yarn Color': 'Yarn Color',
    'Yarn Weight': 'Yarn Weight',
    'Yarn Properties': 'Yarn Properties',
    'Yarn Supplier': 'Yarn Supplier',
    'Enter Yarn Code': 'Enter Yarn Code',
    'Enter Yarn Type': 'Enter Yarn Type',
    'Enter Yarn Color': 'Enter Yarn Color',
    'Enter Yarn Weight': 'Enter Yarn Weight',
    'Enter Yarn Properties': 'Enter Yarn Properties',
    'Select Yarn Supplier': 'Select Yarn Supplier',
    'Yarn Code Required': 'Yarn Code is required',
    'Yarn Type Required': 'Yarn Type is required',
    'Yarn Color Required': 'Yarn Color is required',
    'Yarn Weight Required': 'Yarn Weight is required',
    'Yarn Properties Required': 'Yarn Properties is required',
    'Yarn Supplier Required': 'Yarn Supplier is required',

    // Delete Modal
    'Confirm Delete': 'Confirm Delete',
    'Are you sure you want to delete this stock status?': 'Are you sure you want to delete this stock status?',
    'This action cannot be undone.': 'This action cannot be undone.',
    'Edit Stock Status': 'Edit Stock Status',
    'Delete Stock Status': 'Delete Stock Status',
    'No data found.': 'No data found.',
    'Loading data...': 'Loading data...',
    'Cancel': 'Cancel',
    'Delete': 'Delete',

    // Material Status
    'Material Status': 'Material Status',
    'materialStatusName': 'Material Status Name',
    'materialStatusDescription': 'Material Status Description',
    'enterMaterialStatusName': 'Enter Material Status Name',
    'enterMaterialStatusDescription': 'Enter Material Status Description',
    'materialStatusNameRequired': 'Material Status Name is required',
    'materialStatusDescriptionRequired': 'Material Status Description is required',
    'materialStatusCreated': 'Material status created successfully',
    'materialStatusUpdated': 'Material status updated successfully',
    'materialStatusDeleted': 'Material status deleted successfully',
    'createMaterialStatus': 'Create Material Status',
    'updateMaterialStatus': 'Update Material Status',
    'deleteMaterialStatus': 'Delete Material Status',
    'confirmDeleteMaterialStatus': 'Are you sure you want to delete this material status?',

    // Yarn Status
    'Yarn Status': 'Yarn Status',
    'yarnStatusName': 'Yarn Status Name',
    'yarnStatusDescription': 'Yarn Status Description',
    'enterYarnStatusName': 'Enter Yarn Status Name',
    'enterYarnStatusDescription': 'Enter Yarn Status Description',
    'yarnStatusNameRequired': 'Yarn Status Name is required',
    'yarnStatusDescriptionRequired': 'Yarn Status Description is required',
    'yarnStatusCreated': 'Yarn status created successfully',
    'yarnStatusUpdated': 'Yarn status updated successfully',
    'yarnStatusDeleted': 'Yarn status deleted successfully',
    'createYarnStatus': 'Create Yarn Status',
    'updateYarnStatus': 'Update Yarn Status',
    'deleteYarnStatus': 'Delete Yarn Status',
    'confirmDeleteYarnStatus': 'Are you sure you want to delete this yarn status?',

    // Thread Status
    'Thread Status': 'Thread Status',
    'threadStatusName': 'Thread Status Name',
    'threadStatusDescription': 'Thread Status Description',
    'enterThreadStatusName': 'Enter Thread Status Name',
    'enterThreadStatusDescription': 'Enter Thread Status Description',
    'threadStatusNameRequired': 'Thread Status Name is required',
    'threadStatusDescriptionRequired': 'Thread Status Description is required',
    'threadStatusCreated': 'Thread status created successfully',
    'threadStatusUpdated': 'Thread status updated successfully',
    'threadStatusDeleted': 'Thread status deleted successfully',
    'createThreadStatus': 'Create Thread Status',
    'updateThreadStatus': 'Update Thread Status',
    'deleteThreadStatus': 'Delete Thread Status',
    'confirmDeleteThreadStatus': 'Are you sure you want to delete this thread status?',

    // Weave Status
    'Weave Status': 'Weave Status',
    'weaveStatusName': 'Weave Status Name',
    'weaveStatusDescription': 'Weave Status Description',
    'enterWeaveStatusName': 'Enter Weave Status Name',
    'enterWeaveStatusDescription': 'Enter Weave Status Description',
    'weaveStatusNameRequired': 'Weave Status Name is required',
    'weaveStatusDescriptionRequired': 'Weave Status Description is required',
    'weaveStatusCreated': 'Weave status created successfully',
    'weaveStatusUpdated': 'Weave status updated successfully',
    'weaveStatusDeleted': 'Weave status deleted successfully',
    'createWeaveStatus': 'Create Weave Status',
    'updateWeaveStatus': 'Update Weave Status',
    'deleteWeaveStatus': 'Delete Weave Status',
    'confirmDeleteWeaveStatus': 'Are you sure you want to delete this weave?',

    // Color Status
    'Color Status': 'Color Status',
    'colorStatusName': 'Color Status Name',
    'colorStatusDescription': 'Color Status Description',
    'enterColorStatusName': 'Enter Color Status Name',
    'enterColorStatusDescription': 'Enter Color Status Description',
    'colorStatusNameRequired': 'Color Status Name is required',
    'colorStatusDescriptionRequired': 'Color Status Description is required',
    'colorStatusCreated': 'Color status created successfully',
    'colorStatusUpdated': 'Color status updated successfully',
    'colorStatusDeleted': 'Color status deleted successfully',
    'createColorStatus': 'Create Color Status',
    'updateColorStatus': 'Update Color Status',
    'deleteColorStatus': 'Delete Color Status',
    'confirmDeleteColorStatus': 'Are you sure you want to delete this color status?',

    // Unit Status
    'Unit Status': 'Unit Status',
    'unitStatusName': 'Unit Status Name',
    'unitStatusDescription': 'Unit Status Description',
    'enterUnitStatusName': 'Enter Unit Status Name',
    'enterUnitStatusDescription': 'Enter Unit Status Description',
    'unitStatusNameRequired': 'Unit Status Name is required',
    'unitStatusDescriptionRequired': 'Unit Status Description is required',
    'unitStatusCreated': 'Unit status created successfully',
    'unitStatusUpdated': 'Unit status updated successfully',
    'unitStatusDeleted': 'Unit status deleted successfully',
    'createUnitStatus': 'Create Unit Status',
    'updateUnitStatus': 'Update Unit Status',
    'deleteUnitStatus': 'Delete Unit Status',
    'confirmDeleteUnitStatus': 'Are you sure you want to delete this unit status?',

    // Composition Status
    'Composition Status': 'Composition Status',
    'compositionStatusName': 'Composition Status Name',
    'compositionStatusDescription': 'Composition Status Description',
    'enterCompositionStatusName': 'Enter Composition Status Name',
    'enterCompositionStatusDescription': 'Enter Composition Status Description',
    'compositionStatusNameRequired': 'Composition Status Name is required',
    'compositionStatusDescriptionRequired': 'Composition Status Description is required',
    'compositionStatusCreated': 'Composition status created successfully',
    'compositionStatusUpdated': 'Composition status updated successfully',
    'compositionStatusDeleted': 'Composition status deleted successfully',
    'createCompositionStatus': 'Create Composition Status',
    'updateCompositionStatus': 'Update Composition Status',
    'deleteCompositionStatus': 'Delete Composition Status',
    'confirmDeleteCompositionStatus': 'Are you sure you want to delete this composition status?',

    // Weave Color Status
    'Weave Color Status': 'Weave Color Status',
    'weaveColorStatusName': 'Weave Color Status Name',
    'weaveColorStatusDescription': 'Weave Color Status Description',
    'enterWeaveColorStatusName': 'Enter Weave Color Status Name',
    'enterWeaveColorStatusDescription': 'Enter Weave Color Status Description',
    'weaveColorStatusNameRequired': 'Weave Color Status Name is required',
    'weaveColorStatusDescriptionRequired': 'Weave Color Status Description is required',
    'weaveColorStatusCreated': 'Weave color status created successfully',
    'weaveColorStatusUpdated': 'Weave color status updated successfully',
    'weaveColorStatusDeleted': 'Weave color status deleted successfully',
    'createWeaveColorStatus': 'Create Weave Color Status',
    'updateWeaveColorStatus': 'Update Weave Color Status',
    'deleteWeaveColorStatus': 'Delete Weave Color Status',
    'confirmDeleteWeaveColorStatus': 'Are you sure you want to delete this weave color status?',

    // Currency Status
    'Currency Status': 'Currency Status',
    'currencyStatusName': 'Currency Status Name',
    'currencyStatusDescription': 'Currency Status Description',
    'enterCurrencyStatusName': 'Enter Currency Status Name',
    'enterCurrencyStatusDescription': 'Enter Currency Status Description',
    'currencyStatusNameRequired': 'Currency Status Name is required',
    'currencyStatusDescriptionRequired': 'Currency Status Description is required',
    'currencyStatusCreated': 'Currency status created successfully',
    'currencyStatusUpdated': 'Currency status updated successfully',
    'currencyStatusDeleted': 'Currency status deleted successfully',
    'createCurrencyStatus': 'Create Currency Status',
    'updateCurrencyStatus': 'Update Currency Status',
    'deleteCurrencyStatus': 'Delete Currency Status',
    'confirmDeleteCurrencyStatus': 'Are you sure you want to delete this currency?',

    // Weave Type Status
    'Weave Type Status': 'Weave Type Status',
    'weaveTypeStatusName': 'Weave Type Status Name',
    'weaveTypeStatusDescription': 'Weave Type Status Description',
    'enterWeaveTypeStatusName': 'Enter Weave Type Status Name',
    'enterWeaveTypeStatusDescription': 'Enter Weave Type Status Description',
    'weaveTypeStatusNameRequired': 'Weave Type Status Name is required',
    'weaveTypeStatusDescriptionRequired': 'Weave Type Status Description is required',
    'weaveTypeStatusCreated': 'Weave type status created successfully',
    'weaveTypeStatusUpdated': 'Weave type status updated successfully',
    'weaveTypeStatusDeleted': 'Weave type status deleted successfully',
    'createWeaveTypeStatus': 'Create Weave Type Status',
    'updateWeaveTypeStatus': 'Update Weave Type Status',
    'deleteWeaveTypeStatus': 'Delete Weave Type Status',
    'confirmDeleteWeaveTypeStatus': 'Are you sure you want to delete this weave type?',

    // Common
    'Status ID': 'Status ID',
    'Status Name': 'Status Name',
    'Description': 'Description',
    'Actions': 'Actions',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Delete': 'Delete',
    'Edit': 'Edit',
    'Saving': 'Saving...',
    'Creating': 'Creating...',
    'Updating': 'Updating...',
    'Deleting': 'Deleting...',

    // Weave Table Specific
    weaveCode: 'Weave Code',
    weaveCodeTip: 'Weave Code',
    warpYarn: 'Warp Yarn',
    weftYarn: 'Weft Yarn',
    warpDensity: 'Warp Density',
    weftDensity: 'Weft Density',
    reedWidth: 'Reed Width',
    totalThreads: 'Total Threads',
    yarnCode: 'Yarn Code',
    weftYarnCode: 'Weft Yarn Code',
    yarnNumber: 'Yarn Number',
    weftYarnName: 'Weft Yarn Name',
    waftWeight: 'Warp Weight',
    show: 'Show',
    entries: 'entries',
    paginationInfo: 'Showing {{start}} to {{end}} of {{total}} entries',
    filters: 'Filters',
    clearFilters: 'Clear Filters',
    search: 'Search',
    resultsFound: 'results found',
    totalRecords: 'total records',
    noResultsFound: 'No results found matching your search criteria',
    clearFiltersToSeeAll: 'Clear filters to see all records',

    // --- ADDED FOR WEAVE INPUTS TABLE ---
    colorName: 'Color Name',
    colorNumber: 'Color Number',
    total: 'Total',
    percent: '%',
    action: 'Action',
    addRow: 'Add Row',
    rows: 'Rows',
    addColumn: 'Add Column',
    removeColumn: 'Remove Column',
    removeRow: 'Remove Row',
    selectColor: 'Select Color',
    warpColorReport: 'WARP COLOR REPORT',
    weftColorReport: 'WEFT COLOR REPORT',
    totalLabel: 'TOTAL:',
    successfullySaved: 'Successfully saved!',

    // Common Actions and Labels
    actions: 'Actions',
    id: 'ID',
    description: 'Description',
    cancel: 'Cancel',
    delete: 'Delete',

    // Weave Status Actions
    updateWeaveStatus: 'Update Weave',
    deleteWeaveStatus: 'Delete Weave',
    confirmDeleteWeaveStatus: 'Are you sure you want to delete this weave?',

    userManagement: 'User Management',
    userList: 'User List',
    createUser: 'Create User',
    updateUser: 'Update User',
    deleteUser: 'Delete User',
    editUser: 'Edit User',
    userDetails: 'User Details',
    userInformation: 'User Information',

    // User Fields
    userId: 'User ID',
    userName: 'Username',
    userEmail: 'Email',
    userFullName: 'Full Name',
    surname: 'Surname',
    mobilePhone: 'Mobile Phone',
    userPhone: 'Phone',
    userRole: 'Role',
    userDepartment: 'Department',
    userStatus: 'Status',
    userCreatedDate: 'Created Date',
    userLastLogin: 'Last Login',

    // User Form Fields
    enterUserName: 'Enter username',
    enterUserEmail: 'Enter email address',
    enterUserFullName: 'Enter full name',
    enterSurname: 'Enter surname',
    enterMobilePhone: 'Enter mobile phone',
    enterUserPhone: 'Enter phone number',
    selectUserRole: 'Select user role',
    selectUserDepartment: 'Select department',
    selectUserStatus: 'Select status',
    updateSample: 'Update Sample',
    enterWeaveCode: 'Enter weave code',
    createWeaveFromSampleDescription: 'Create a new weave based on the selected sample weave',

    // User Validation
    userNameRequired: 'Username is required',
    userEmailRequired: 'Email is required',
    userFullNameRequired: 'Full name is required',
    surnameRequired: 'Surname is required',
    mobilePhoneRequired: 'Mobile phone number is required',
    userPhoneRequired: 'Phone number is required',
    userRoleRequired: 'User role is required',
    userDepartmentRequired: 'Department is required',
    userStatusRequired: 'User status is required',
    invalidEmailFormat: 'Invalid email format',
    invalidPhoneFormat: 'Invalid phone number format',

    // User Messages
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    userDeleteWarning: 'This action will permanently delete the user account and cannot be undone.',

    // User Roles
    admin: 'Administrator',
    manager: 'Manager',
    employee: 'Employee',
    viewer: 'Viewer',

    // User Departments
    production: 'Production',
    sales: 'Sales',
    accounting: 'Accounting',
    hr: 'Human Resources',
    it: 'Information Technology',

    // User Status
    activeUser: 'Active',
    inactiveUser: 'Inactive',
    suspendedUser: 'Suspended',
    pendingUser: 'Pending',

    // User Actions
    createNewUser: 'Create New User',
    viewUserProfile: 'View Profile',
    resetPassword: 'Reset Password',
    changeUserStatus: 'Change Status',
    userPermissions: 'User Permissions',

    // Password Reset
    resetUserPassword: 'Reset Password',
    confirmResetPassword: 'Are you sure you want to reset this user\'s password?',
    //  resetUserPasswordWarning: 'The new password will be sent to the user via email.',
    passwordResetSuccess: 'Password Successfully Reset!',
    passwordResetSuccessMessage: 'The user\'s password has been successfully reset.',
    passwordResetError: 'Password Reset Error!',
    passwordResetErrorMessage: 'An error occurred while resetting the password.',
    activationCode: 'Activation Code',
    activationCodeNote: 'Keep this activation code safe and provide it to the user.',
    newPassword: 'New Password',
    newPasswordNote: 'Keep this password safe and provide it to the user.',
    close: 'Close',

    // Change Password
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    enterCurrentPassword: 'Enter your current password',
    enterNewPassword: 'Enter your new password',
    confirmNewPassword: 'Confirm your new password',
    currentPasswordRequired: 'Current password is required',
    newPasswordRequired: 'New password is required',
    passwordTooShort: 'New password must be at least 6 characters',
    passwordsNotMatch: 'New passwords do not match',
    newPasswordSameAsCurrent: 'New password cannot be the same as current password',
    passwordChangedSuccessfully: 'Password changed successfully',
    passwordChangeError: 'Error occurred while changing password',
    passwordMinLength: 'Password must be at least 6 characters',
    changing: 'Changing...',
    logout: 'Logout',
    userSessionNotFound: 'User session not found. Please login again.',

    // Password Strength
    passwordStrength: 'Password Strength',
    weakPassword: 'Weak',
    mediumPassword: 'Medium',
    strongPassword: 'Strong',
    veryStrongPassword: 'Very Strong',
    passwordRequirements: 'Use at least 6 characters with uppercase, lowercase, numbers and special characters',
    passwordsMatch: 'Paswords Match',

    // User Details
    viewUserDetails: 'View User Details',
    userNotFound: 'User not found',
    goBack: 'Go Back',
    personalInfo: 'Personal Information',
    systemInfo: 'System Information',
    generalInfo: 'General Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    lastLogin: 'Last Login',
    createdDate: 'Created Date',
    updatedDate: 'Updated Date',
    status: 'Status',
    justNow: 'Just Now',
    minutesAgo: 'Minutes Ago',
    hoursAgo: 'Hours Ago',
    daysAgo: 'Days Ago',
    monthsAgo: 'Months Ago',
    yearsAgo: 'Years Ago',

    // Sessions Tab
    sessions: 'Sessions',
    sessionId: 'Session ID',
    expireTime: 'Expire Time',
    jwt: 'JWT Token',
    noSessionsFound: 'No active sessions found',

    // Password History Tab
    passwordHistory: 'Password History',
    passwordId: 'Password ID',
    createdBy: 'Created By',
    noPasswordHistoryFound: 'No password history found',
    customerId: 'Customer ID',
    customerName: 'Customer Name',
    customerDescription: 'Customer Description',
    address: 'Address',
    contact: 'Contact',
    createCustomer: 'Create Customer',
    updateCustomer: 'Update Customer',
    deleteCustomer: 'Delete Customer',
    editCustomer: 'Edit Customer',
    customerCreated: 'Customer created successfully',
    customerUpdated: 'Customer updated successfully',
    customerDeleted: 'Customer deleted successfully',
    confirmDeleteCustomer: 'Are you sure you want to delete this customer?',
    customerDeleteWarning: 'This action will permanently delete the customer and cannot be undone.',
    enterCustomerName: 'Enter customer name',
    enterCustomerDescription: 'Enter customer description',
    enterAddress: 'Enter address',
    enterCepTel: 'Enter mobile phone',
    enterTelefon: 'Enter phone',
    enterContact: 'Enter contact',
    enterEmail: 'Enter email address',
    customerNameRequired: 'Customer name is required',
    customerDescriptionRequired: 'Customer description is required',
    addressRequired: 'Address is required',
    cepTelRequired: 'Mobile phone is required',
    telefonRequired: 'Phone is required',
    contactRequired: 'Contact is required',
    suppliers: 'Suppliers',
    supplierId: 'Supplier ID',
    supplierName: 'Supplier Name',
    savedSuppliers: 'Saved Suppliers',
    supplierDescription: 'Supplier Description',
    createSupplier: 'Create Supplier',
    updateSupplier: 'Update Supplier',
    deleteSupplier: 'Delete Supplier',
    editSupplier: 'Edit Supplier',
    supplierCreated: 'Supplier created successfully',
    supplierUpdated: 'Supplier updated successfully',
    supplierDeleted: 'Supplier deleted successfully',
    confirmDeleteSupplier: 'Are you sure you want to delete this supplier?',
    supplierDeleteWarning: 'This action will permanently delete the supplier and cannot be undone.',
    enterSupplierName: 'Enter supplier name',
    enterSupplierDescription: 'Enter supplier description',
    supplierNameRequired: 'Supplier name is required',
    supplierDescriptionRequired: 'Supplier description is required',

    // Session ve Network Error Messages
    sessionExpired: 'Session expired. Please login again.',
    networkErrorSessionTimeout: 'Could not connect to server. Your session is being terminated.',
    unauthorizedError: 'You do not have permission. Please login again.',
    accessDeniedError: 'Access denied. Please login again.',
    sessionError: 'Session error occurred.',
    connectionError: 'Connection Error!',
    networkError: 'Network Error!',
    connectionErrorMessage: 'Could not connect to server. Please check your internet connection.',
    sessionTimeoutTitle: 'Session Timeout!',
    sessionTimeoutMessage: 'Your session has expired. You are being redirected to login page.',
    unexpectedError: 'Unexpected Error!',
    unexpectedErrorMessage: 'An unexpected error occurred',

    // HTTP Error Messages
    httpError: 'HTTP Error',
    serverError: 'Server Error',
    notFoundError: 'Resource not found',
    badRequestError: 'Invalid request',
    payloadTooLargeError: 'File Too Large',
    fileTooLargeError: 'The file you are trying to upload is too large.',
    internalServerError: 'Internal server error',
    serviceUnavailableError: 'Service temporarily unavailable',

    // API Error Messages
    apiError: 'API Error!',
    requestFailedError: 'Request failed',
    invalidResponseError: 'Invalid response received from server',
    timeoutError: 'Request timeout',

    // General Error Messages
    operationFailed: 'Operation failed',
    dataLoadError: 'Error loading data',
    userLoadError: 'Error loading user information',
    saveError: 'Error saving data',
    deleteError: 'Error deleting data',
    updateError: 'Error updating data',

    // Login Page
    login: 'Login',
    signInToYourAccount: 'Sign In to your account',
    username: 'Username',
    password: 'Password',
    welcomeBack: 'Welcome Back!',
    signInToContinue: 'Sign in to continue',
    rememberMe: 'Remember me',
    startYourJourney: 'Start Your Journey',
    loginDescription: 'Access your dashboard with secure authentication',
    secureAuthentication: 'Secure authentication',
    dataProtection: 'Data protection',
    '24_7Support': '24/7 Support',
    signIn: 'Sign In',

    // Form Validations
    usernameRequired: 'Username cannot be blank.',
    passwordRequired: 'Password cannot be blank.',

    // Two Factor Authentication
    twoFactorAuthentication: 'Two Factor Authentication',
    enter2FACode: 'Enter 2FA code:',
    enter: 'Enter',
    close: 'Close',

    balance: 'Balance',
    shipments: 'Shipments',
    shipmentId: 'Shipment ID',
    opsShipmentStatusGuid: 'Shipment Status Guid',
    prdUnitGuid: 'Production Unit Guid',
    billingCompany: 'Billing Company',
    shipmentDatetime: 'Shipment Datetime',
    deliveryNo: 'Delivery No',
    description: 'Description',
    productShippedQuantity: 'Product Shipped Quantity',
    netWeight: 'Net Weight',
    grossWeight: 'Gross Weight',
    opsOrderGuid: 'Order Guid',
    createShipment: 'Create Shipment',
    updateShipment: 'Update Shipment',
    deleteShipment: 'Delete Shipment',
    editShipment: 'Edit Shipment',
    shipmentCreated: 'Shipment created successfully',
    shipmentUpdated: 'Shipment updated successfully',
    shipmentDeleted: 'Shipment deleted successfully',
    confirmDeleteShipment: 'Are you sure you want to delete this shipment?',
    shipmentDeleteWarning: 'This action will permanently delete the shipment and cannot be undone.',
    enterOpsShipmentStatusGuid: 'Enter shipment status guid',
    enterPrdUnitGuid: 'Enter production unit guid',
    enterBillingCompany: 'Enter billing company',
    enterShipmentDatetime: 'Enter shipment datetime',
    enterDeliveryNo: 'Enter delivery no',
    enterDescription: 'Enter description',
    enterProductShippedQuantity: 'Enter product shipped quantity',
    enterOpsOrderGuid: 'Enter order guid',
    opsShipmentStatusGuidRequired: 'Shipment status guid is required',
    prdUnitGuidRequired: 'Production unit guid is required',
    billingCompanyRequired: 'Billing company is required',
    shipmentDatetimeRequired: 'Shipment datetime is required',
    deliveryNoRequired: 'Delivery no is required',
    descriptionRequired: 'Description is required',
    productShippedQuantityRequired: 'Product shipped quantity is required',
    opsOrderGuidRequired: 'Order guid is required',
    stock: 'Stock',
    createStock: 'Create Stock',
    updateStock: 'Update Stock',
    deleteStock: 'Delete Stock',
    editStock: 'Edit Stock',
    stockId: 'Stock ID',
    prdUnitGuid: 'Production Unit Guid',
    opsStockStatusGuid: 'Stock Status Guid',
    dailyProduction: 'Daily Production',
    opsStockStatus: 'Stock Status ',
    productStockQuantity: 'Product Stock Quantity',
    stockPlace: 'Stock Place',
    lot: 'Lot',
    description: 'Description',
    orderGuid: 'Order Guid',
    orderGuidRequired: 'Order Guid is required',
    prdUnitGuidRequired: 'Production Unit Guid is required',
    opsStockStatusGuidRequired: 'Stock Status Guid is required',
    productStockQuantityRequired: 'Product Stock Quantity is required',
    stockPlaceRequired: 'Stock Place is required',
    lotRequired: 'Lot is required',
    stockCreated: 'Stock created successfully',
    stockUpdated: 'Stock updated successfully',
    stockDeleted: 'Stock deleted successfully',
    confirmDeleteStock: 'Are you sure you want to delete this stock?',
    stockDeleteWarning: 'This action will permanently delete the stock and cannot be undone.',
    // Product
    products: 'Products',
    createProduct: 'Create Product',
    updateProduct: 'Update Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete Product',
    confirmDeleteProduct: 'Are you sure you want to delete this product?',
    productDeleteWarning: 'This action will permanently delete the product and cannot be undone.',
    weaveCreatedSuccessfully: 'Product created successfully!',
    productDetails: 'Product Details',
    productInformation: 'Product Information',
    weaveDetails: 'Weave Details',
    orderDetails: 'Order Details',
    allOrdersForThisProduct: 'All orders for this product',
    order: 'Order',
    orderDescription: 'Order Description',
    loadingProductDetails: 'Loading product details...',
    errorLoadingProductDetails: 'Error loading product details',
    productCode: 'Product Code',
    weaveCode: 'Weave Code',
    weaveType: 'Weave Type',
    warpYarn: 'Warp Yarn',
    weftYarn: 'Weft Yarn',
    threadName: 'Thread Name',
    threadCompositionName: 'Mixture Name',
    warpDensity: 'Warp Density',
    weftDensity: 'Weft Density',
    reedWidth: 'Reed Width',
    totalThreads: 'Total Threads',
    reedNo: 'Reed No',
    dgts: 'DGTS',
    customer: 'Customer',
    supplier: 'Supplier',
    unit: 'Unit',
    paymentTerm: 'Payment Term',
    enterPaymentTerm: 'Enter payment term',
    shipmentPlace: 'Shipment Place',
    enterShipmentPlace: 'Enter shipment place',
    currency: 'Currency',
    orderStatus: 'Order Status',
    orderDate: 'Order Date',
    deadline: 'Deadline',
    quantity: 'Quantity',
    costPrice: 'Cost Price',
    salesPrice: 'Sales Price',

    // ProductDetailCard specific translations
    certificate: 'Certificate',
    lot: 'Lot',
    description: 'Description',
    materialName: 'Material Name',
    weaveTypeName: 'Weave Type Name',
    warpYarnName: 'Warp Yarn Name',
    weftYarnName: 'Weft Yarn Name',
    threadName: 'Thread Name',
    customerName: 'Customer Name',
    supplierName: 'Supplier Name',
    unitName: 'Unit Name',
    currencyName: 'Currency Name',
    orderDatetime: 'Order Datetime',
    orderDeadlineDatetime: 'Order Deadline Datetime',
    productQuantity: 'Product Quantity',
    productCostPrice: 'Product Cost Price',
    productSalesPrice: 'Product Sales Price',
    // Product Fields
    prdWeavesGuid: 'Weave Guid',
    enterPrdWeavesGuid: 'Enter weave guid',
    prdWeavesGuidRequired: 'Weave guid is required',
    prdMaterialGuid: 'Material Guid',
    enterPrdMaterialGuid: 'Enter material guid',
    prdMaterialGuidRequired: 'Material guid is required',
    productCodeForCustomer: 'Product Code',
    enterProductCodeForCustomer: 'Enter product code',
    productCodeForCustomerRequired: 'Product code is required',
    certificate: 'Certificate',
    enterCertificate: 'Enter certificate',
    certificateRequired: 'Certificate is required',
    lot: 'Lot',
    enterLot: 'Enter lot',
    lotRequired: 'Lot is required',

    // Technical Product Fields
    weight: 'Weight',
    warpThreadCount: 'Warp Thread Count',
    enterWarpThreadCount: 'Enter warp thread count',
    reedNo: 'Reed No',
    enterReedNo: 'Enter reed no',
    dgts: 'DGTS',
    enterDGTS: 'Enter DGTS',
    enterWarpDensity: 'Enter Warp Density',
    reedWidth: 'Reed Width',
    enterReedWidth: 'Enter reed width',
    weftDensity: 'Weft Density',
    enterWeftDensity: 'Enter weft density',
    weaveCombo: 'Weave (Combo)',
    enterWeaveCombo: 'Enter weave combo',
    warpNE: 'Warp NE',
    enterWarpNE: 'Enter warp NE',
    weftNE: 'Weft NE',
    enterWeftNE: 'Enter weft NE',
    warpWeight: 'Warp Weight',
    waftWeight: 'Warp Weight',
    enterWarpWeight: 'Enter warp weight',
    weftWeight: 'Weft Weight',
    enterWeftWeight: 'Enter weft weight',
    totalWeight: 'Total Weight',
    enterTotalWeight: 'Enter total weight',
    weaveTypeSelection: 'Weave Type Selection',
    colorReport: 'COLOR REPORT',
    warp: 'Warp',
    weft: 'Weft',
    row: 'Row',
    column: 'Column',
    add: 'Add',
    remove: 'Remove',
    colorName: 'Color Name',
    colorNumber: 'Color Number',
    yarnName: 'Yarn Name',
    yarnCode: 'Yarn Code',
    total: 'Total',
    action: 'Action',
    addRow: 'Add Row',
    columns: 'Columns',
    addColumn: 'Add Column',
    removeColumn: 'Remove Column',
    removeRow: 'Remove Row',
    selectColor: 'Select Color',
    selectYarn: 'Select Yarn',
    warpColorReport: 'WARP COLOR REPORT',
    weftColorReport: 'WEFT COLOR REPORT',
    totalLabel: 'TOTAL:',
    successfullySaved: 'Successfully saved!',

    //Weave Factor
    addFactor: 'Add Factor',
    firstColumn: 'First Column',
    secondColumn: 'Second Column',
    factor: 'Factor',
    incomingAmount: 'Incoming Amount',
    supplierDatetime: 'Supplier Date',
    leftoverYarn: 'Leftover Yarn',
    preparedYarn:'Prepared Yarn',

    // Order Details Page
    customerCode: 'Customer Code',
    customerProductCode: 'Customer Product Code',
    orderDetails: 'Order Details',
    loadingOrderDetails: 'Loading order details...',
    orderLoadError: 'An error occurred while loading order information.',
    orderNotFound: 'Order not found.',
    apiNotice: 'Note: Detailed order information API is being implemented. Currently showing basic order data from the table.',
    orderInfo: 'Order Information',
    productInfo: 'Product Information',
    statusInfo: 'Status Information',
    basicInfo: 'Basic Information',
    dateInfo: 'Date Information',
    quantityAndPrice: 'Quantity and Price Information',
    orderId: 'Order ID',
    productCode: 'Product Code',
    customer: 'Customer',
    supplier: 'Supplier',
    unit: 'Unit',
    currency: 'Currency',
    orderDate: 'Order Date',
    deadline: 'Deadline',
    productionStart: 'Production Start',
    productionEnd: 'Production End',
    quantity: 'Quantity',
    costPrice: 'Cost Price',
    salesPrice: 'Sales Price',
    rowNumber: '#',
    totalPrice: 'Total Price',
    dispatchQuantity: 'Dispatch Quantity',
    stockQuantity: 'Stock Quantity',
    remainingQuantity: 'Remaining Quantity',
    requirementMeter: 'Requirement Meter',
    productDetails: 'Product Details',
    certificateAndLot: 'Certificate and Lot Information',
    productId: 'Product ID',
    weaveCode: 'Weave Code',
    materialName: 'Material Name',
    insertDatetime: 'Created Date',
    noProductDetailsFound: 'No Product Details Found',
    apiNotImplemented: 'Detailed product information will be available when the API is fully implemented.',
    orderStatusDetails: 'Order Status Details',
    statusName: 'Status Name',
    statusDescription: 'Status Description',
    noStatusDetailsFound: 'No Status Details Found',
    viewDetails: 'View Details',
    orderAction: 'Order Action',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
    futureDate: 'Future Date',
    noProductDetailsDescription: 'No product details found for this order.',
    noStatusDetailsDescription: 'No status details found for this order.',
    selectSupplierType: 'Select Supplier Type',
    selectSupplierTypeFirst: 'Please select a supplier type to continue',
    selectSupplier: 'Select Supplier',
    selectSupplierFirst: 'Please select a supplier to continue',
    selectCurrency: 'Select Currency',
    // Shipment Information
    shipmentInfo: 'Shipment Information',
    shipmentDetails: 'Shipment Details',
    shipmentCount: 'Total',
    shipment: 'shipment',
    shipmentList: 'Shipment List',
    shipmentCode: 'Shipment Code',
    shipmentId: 'Shipment Id',
    shipmentDate: 'Shipment Date',
    deliveryNo: 'Delivery No',
    billingCompany: 'Billing Company',
    status: 'Status',
    unit: 'Unit',
    quantity: 'Quantity',
    description: 'Description',
    noShipmentDetailsFound: 'No Shipment Details Found',
    noShipmentDetailsDescription: 'No shipment details found for this order.',
    selectWeaveColor: 'Select Weave Color',
    days: 'Days',

    // Stock Information
    stockInfo: 'Stock Information',
    stockDetails: 'Stock Details',
    stockCount: 'Total',
    stockList: 'Stock List',
    stockId: 'Stock ID',
    stockPlace: 'Stock Place',
    lot: 'Lot',
    insertDate: 'Created Date',
    noStockDetailsFound: 'No Stock Details Found',
    noStockDetailsDescription: 'No stock details found for this order.',

    // Status Badges
    delivered: 'Delivered',
    inTransit: 'In Transit',
    available: 'Available',
    reserved: 'Reserved',
    outOfStock: 'Out of Stock',
    lowStock: 'Low Stock',

    // Order Form Labels (without Guid)
    selectCostCurrency: 'Select Cost Currency',
    selectSalesCurrency: 'Select Sales Currency',
    searchCurrency: 'Search Currency',
    product: 'Product',
    customer: 'Customer',
    supplier: 'Supplier',
    unit: 'Unit',
    currency: 'Currency',
    orderStatus: 'Order Status',
    orderDatetime: 'Order Date',
    orderDeadlineDatetime: 'Deadline Date',
    productQuantity: 'Product Quantity',
    productionStartDatetime: 'Production Start',
    productionEndDatetime: 'Production End',
    productDispatchQuantity: 'Dispatch Quantity',
    productStockQuantity: 'Stock Quantity',
    productRemainingQuantity: 'Remaining Quantity',
    productCostPrice: 'Cost Price',
    productSalesPrice: 'Sales Price',
    productTotalPrice: 'Total Price',
    select: 'Select',

    // Order Action Page
    orderAction: 'Order Action',
    orderActionForm: 'Order Action Form',
    orderStatusChange: 'Status Change',
    viewDetails: 'View Details',
    editOrder: 'Edit Order',
    deleteOrder: 'Delete Order',
    stockAction: 'Stock Action',
    shipmentAction: 'Shipment Action',
    newOrderStatus: 'New Order Status',
    selectStatus: 'Select Status',
    rollCount: 'Roll Count',
    transferToStock: 'Transfer To Stock',
    transferToShipment: 'Transfer To Shipment',
    sourceShipment: 'Source Shipment',
    sourceStock: 'Source Stock',
    targetStock: 'Target Stock',
    targetShipment: 'Target Shipment',
    selectStock: 'Select stock',
    selectShipment: 'Select shipment',
    noStockRecord: 'No suitable stock record found',
    noShipmentRecord: 'No suitable shipment record found',
    transferQuantity: 'Transfer Quantity',
    transferRollCount: 'Transfer Roll Count',
    enterTransferQuantity: 'Enter transfer quantity',
    enterTransferRollCount: 'Enter transfer roll count',
    transferSummary: 'Transfer Summary',
    transferRuleHint: 'At least one field must be greater than 0.',
    transferDetailsHint: 'Check source and target records, then enter transfer values.',
    stockRollCount: 'Stock Rol Count',
    shipmentRollCount: 'Shipment Rol Count',
    enterStockRollCount: 'Enter stock roll count',
    enterShipmentRollCount: 'Enter shipment roll count',
    stockUnit: 'Stock Unit',
    selectUnit: 'Select Unit',
    stockStatus: 'Stock Status',
    selectStockStatus: 'Select Stock Status',
    stockQuantity: 'Stock Quantity',
    enterStockQuantity: 'Enter stock quantity',
    stockPlace: 'Stock Place',
    enterStockPlace: 'Enter stock place',
    lot: 'Lot',
    enterLot: 'Enter lot information',
    stockDescription: 'Stock Description',
    enterStockDescription: 'Enter stock description',
    shipmentStatus: 'Shipment Status',
    selectShipmentStatus: 'Select Shipment Status',
    shipmentUnit: 'Shipment Unit',
    selectShipmentUnit: 'Select Shipment Unit',
    billingCompany: 'Billing Company',
    enterBillingCompany: 'Enter billing company',
    shipmentDatetime: 'Shipment Date',
    deliveryNo: 'Delivery Number',
    enterDeliveryNo: 'Enter delivery number',
    productShippedQuantity: 'Product Shipped Quantity',
    enterProductShippedQuantity: 'Enter product shipped quantity',
    shipmentDescription: 'Shipment Description',
    enterShipmentDescription: 'Enter shipment description',
    executeAction: 'Execute Action',
    processing: 'Processing...',
    orderActionError: 'An error occurred while processing the order action.',
    orderActionSuccess: 'Order action was successfully executed.',
    currentStatus: 'Current Status',

    // Wizard Interface
    actionSelection: 'Action Selection',
    selectActionType: 'Select which actions you want to perform',
    configureOrderStatus: 'Configure order status',
    configureStockAction: 'Configure stock action',
    configureShipmentAction: 'Configure shipment action',
    reviewAndSubmit: 'Review and Submit',
    reviewAllActions: 'Review all actions and submit',
    changeOrderStatus: 'Change order status',
    manageStock: 'Manage stock operations',
    manageShipment: 'Manage shipment operations',
    step: 'Step',
    next: 'Next',
    previous: 'Previous',
    selectedActions: 'Selected Actions',
    notSet: 'Not Set',

    // Validation Messages
    newOrderStatusRequired: 'New order status is required',
    stockUnitRequired: 'Stock unit is required',
    stockStatusRequired: 'Stock status is required',
    stockQuantityRequired: 'Stock quantity is required',
    stockPlaceRequired: 'Stock place is required',
    lotRequired: 'Lot information is required',
    shipmentStatusRequired: 'Shipment status is required',
    shipmentUnitRequired: 'Shipment unit is required',
    billingCompanyRequired: 'Billing company is required',
    shipmentDatetimeRequired: 'Shipment date is required',
    deliveryNoRequired: 'Delivery number is required',
    selectAtLeastOneAction: 'Please select at least one action',
    allStepsCompleted: 'All steps completed. You can now execute the action.',
    stepsIncomplete: 'Not all steps are completed. Please fill in missing information.',
    required: 'Required',
    requiredActions: 'Required Actions',

    "filters": "Filters",
    "clearFilters": "Clear Filters",
    "search": "Search",
    "min": "Min",
    "max": "Max",
    "resultsFound": "results found",
    "totalRecords": "total records",
    "noResultsFound": "No results found matching your search criteria",
    "clearFiltersToSeeAll": "Clear filters to see all records",

    // Existing keys check (don't add if already exists)
    "show": "Show",
    "entries": "entries",
    "Showing": "Showing",
    "to": "to",
    "of": "of",
    "loadingData": "Loading data...",
    "noDataFound": "No data found",
    sampleFormats: 'Sample Formats',
    totalWarpWeight: 'Total Warp Weight',
    totalWeftWeight: 'Total Weft Weight',

    //Export
    export: 'Export',
    chooseExportFormat: 'Choose export format',
    exportInfo: 'Export Info',
    recordsWillBeExported: 'records will be exported.',
    exportData: 'Export Data',
    selectExportFormat: 'Select export format',
    selectExportOptions: 'Select export options',
    exportScope: 'Export Scope',
    exportCurrentPage: 'Export Current Page',
    recordsOnThisPage: 'records on this page',
    exportAllResults: 'Export All Results',
    totalFilteredRecords: 'total records (all filtered results)',
    exportFormat: 'File Format',
    exportDetails: 'Export details:',
    filtersApplied: 'Applied filters will be included',
    actionColumnsExcluded: 'Action columns will be excluded',
    downloadFile: 'Download File',
    // Export - Preview & Print additions
    preview: 'Preview',
    print: 'Print',
    dataPreview: 'Data Preview',
    previewNote: 'Note: Only the first 10 records are shown. All data will be exported.',
    scope: 'Scope',
    allResults: 'All Results',
    currentPage: 'Current Page',
    printDate: 'Print Date',
    generatedBy: 'Generated by',
    pageOf: 'Page',
    records: 'records',
    // Reports
    reports: 'Reports',
    customerAgreementReport: 'Customer Agreement',
    caglikReport: 'Warp and Weft Color Reports',
    sampleReport: 'Sample Report',
    sampleReportDescription: 'Select a sample to view, print or export the fabric analysis form as Excel.',
    sampleSelection: 'Sample Selection',
    selectSample: 'Select Sample',
    searchSamplePlaceholder: 'Search by card number...',
    selectAgreement: 'Select Agreement',
    selectWeave: 'Select Weave',
    generateReport: 'Generate Report',
    agreementSelection: 'Agreement Selection',
    weaveSelection: 'Weave Selection',
    selectAgreementDescription: 'Select an agreement to preview, print or export as Excel.',
    caglikReportDescription: 'Select a weave to view, print or export color reports as Excel.',
    searchPlaceholder: 'Search by customer code, name or article number...',
    searchWeavePlaceholder: 'Search by weave code...',
    reportDetails: 'Report Details',
    errorLoadingDropdown: 'Error loading dropdown',
    errorLoadingReport: 'Error loading report',
    agreementDetails: 'Agreement Details',
    errorLoadingReport: 'Error loading report',
    customerCode: 'Customer Code',
    required: 'required',
    startDate: 'Start Date',
    endDate: 'End Date',
    // Weave Color Selection
    warp: 'WARP',
    weft: 'WEFT',
    select: 'Select',
    position: 'Position',
    selectedYarn: 'Selected Yarn',
    weftWeight: 'Weft Weight',
    waftWeight: 'Warp Weight',
    fabricWidth: 'Finished Fabric Width',
    fabricWeight: 'Finished Fabric Weight',
    grayFabricWidth: 'Gray Fabric Width',
    grayFabricWeight: 'Gray Fabric Weight',

    // Sample fields
    samples: 'Samples',
    createSample: 'Create Sample',
    sampleImage: 'Sample Image',
    selectImage: 'Select Image',
    fabricPhoto: 'Fabric Photo',
    armurePhoto: 'Armure Photo',
    cardNo: 'Card No',
    companyName: 'Company Name',
    certificate: 'Certificate(For Products)',
    date: 'Date',
    price: 'Price',
    totalWireCount: 'Total Wire Count',
    reedNo: 'Reed No',
    grayWarp: 'Gray Warp Density',
    grayWeft: 'Gray Weft Density',

    // Order Supplier
    orderSuppliers: 'Order Suppliers',
    addSupplier: 'Add Supplier',
    unitPrice: 'Unit Price',
    loom: 'Loom',
    loomWarpLength: 'Warp Length',
    weavingStartDate: 'Weaving Start Date',
    loomDailyProduction: 'Daily Production',
    estimatedCompletionTime: 'Est. Completion Time',
    goBack: 'Go Back',
    noSuppliersYet: 'No suppliers added yet',
    clickAddToStart: 'Click Add Supplier to start',
  },
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    user: 'Kullanıcı',
    users: 'Kullanıcılar',
    customers: 'Müşteriler',
    definitions: 'Tanımlamalar',
    orderStatus: 'Sipariş Durumu',
    stockStatus: 'Stok Durumu',
    shipmentStatus: 'Sevkiyat Durumu',
    material: 'Materyal',
    yarn: 'Örgü İplik',
    thread: 'Dikiş İplik',
    weave: 'Tip Kodlama',
    weaveInformation: 'Tip Kodlama Bilgileri',
    color: 'Renk',
    unit: 'Birim',
    composition: 'Kompozisyon',
    weaveColor: 'Dokuma Rengi',
    currency: 'Para Birimi',
    weaveType: 'Dokuma Tipi',
    copyUserId: 'User ID Kopyala',
    copied: 'Kopyalandı',
    Optional: 'Opsiyonel',
    allStatuses: 'Tümü',
    all: 'Tümü',
    clear: 'Temizle',
    userGuide: 'Kullanım Kılavuzu',
    // Theme
    light: 'Aydınlık',
    dark: 'Karanlık',
    auto: 'Otomatik',
    success: 'Başarılı',

    // Common actions
    save: 'Kaydet',
    copyWeave: 'Kopyala',
    newWeaveCode: 'Yeni tip kodu',
    enterNewWeaveCode: 'Yeni tip kodu girin',
    copyWeaveCodeRequired: 'Yeni tip kodu gerekli.',
    copyWeaveNotFound: 'Kopyalanacak kayit bulunamadi.',
    copyWeaveError: 'Kopyalama sirasinda hata olustu.',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    search: 'Ara',
    filter: 'Filtrele',
    confirm: 'Onayla',
    back: 'Geri',

    // Status
    active: 'Aktif',
    inactive: 'Pasif',
    loading: 'Yükleniyor...',
    saving: 'Kaydediliyor...',
    creating: 'Oluşturuluyor...',
    updating: 'Güncelleniyor...',
    deleting: 'Siliniyor...',

    // Language
    language: 'Dil',
    english: 'İngilizce',
    turkish: 'Türkçe',

    // Table Headers
    'Status ID': 'Durum ID',
    'Status Name': 'Durum Adı',
    'Description': 'Açıklama',
    'Actions': 'İşlemler',
    'Show': 'Göster',
    'entries': 'kayıt',
    'Showing': 'Gösteriliyor',
    'to': 'ile',
    'of': 'arası toplam',
    'Previous': 'Önceki',
    'Next': 'Sonraki',
    noDataFound: 'Veri bulunamadı.',
    loadingData: 'Veriler yükleniyor...',
    anErrorOccurred: 'Bir hata oluştu',
    noDataAvailable: 'Veri bulunamadı',

    // Order Status
    createNewOrder: 'Yeni Sipariş Oluştur',
    editOrderStatus: 'Sipariş Durumunu Düzenle',
    deleteOrderStatus: 'Sipariş Durumunu Sil',
    updateOrderStatus: 'Sipariş Durumunu Güncelle',
    createOrderStatus: 'Sipariş Durumu Oluştur',
    orderStatusName: 'Sipariş Durumu Adı',
    orderStatusDescription: 'Sipariş Durumu Açıklaması',
    enterOrderStatusName: 'Sipariş durumu Adını Girin',
    enterOrderStatusDescription: 'Sipariş durumu açıklamasını girin',
    orderStatusNameRequired: 'Sipariş durumu adı zorunludur',
    orderStatusDescriptionRequired: 'Sipariş durumu açıklaması zorunludur',
    orderStatusCreated: 'Sipariş durumu başarıyla oluşturuldu',
    orderStatusUpdated: 'Sipariş durumu başarıyla güncellendi',
    orderStatusDeleted: 'Sipariş durumu başarıyla silindi',
    confirmDeleteOrderStatus: 'Bu sipariş durumunu silmek istediğinizden emin misiniz?',
    thisActionCannotBeUndone: 'Bu işlem geri alınamaz.',
    orders: 'Siparişler',
    order: 'Sipariş',
    createOrder: 'Sipariş Oluştur',
    updateOrder: 'Sipariş Güncelle',
    dailyProduction: 'Günlük Üretim',
    deleteOrder: 'Sipariş Sil',
    editOrder: 'Sipariş Düzenle',
    orderCreated: 'Sipariş başarıyla oluşturuldu',
    orderUpdated: 'Sipariş başarıyla güncellendi',
    orderDeleted: 'Sipariş başarıyla silindi',
    confirmDeleteOrder: 'Bu siparişi silmek istediğinizden emin misiniz?',
    orderDeleteWarning: 'Bu işlem siparişi kalıcı olarak silecek ve geri alınamaz.',
    orderGuid: 'Sipariş Guid',
    previous: 'Önceki',
    next: 'Sonraki',
    prdProductGuid: 'Ürün Guid',
    opsCustomerGuid: 'Müşteri Guid',
    opsSupplierGuid: 'Tedarikçi Guid',
    prdUnitGuid: 'Birim Guid',
    prdCurrencyGuid: 'Para Birimi Guid',
    opsOrderStatusGuid: 'Sipariş Durum Guid',
    orderDatetime: 'Sipariş Tarihi',
    orderDeadlineDatetime: 'Termin Tarihi',
    productQuantity: 'Ürün Miktarı',
    productionStartDatetime: 'Üretim Başlangıç',
    productionEndDatetime: 'Üretim Bitiş',
    productDispatchQuantity: 'Sevk Miktarı',
    productStockQuantity: 'Stok Miktarı',
    productRemainingQuantity: 'Kalan Miktar',
    productCostPrice: 'Maliyet Fiyatı',
    productSalesPrice: 'Satış Fiyatı',
    productTotalPrice: 'Toplam Fiyat',
    orderDescription: 'Sipariş Açıklaması',
    orderDescriptionPlaceholder: 'Sipariş açıklamasını girin',
    note: 'Not',
    notePlaceholder: 'Not girin',
    productCodeForCustomer: 'Ürün Kodu',
    customerName: 'Müşteri Adı',
    supplierName: 'Tedarikçi Adı',
    insertUserGuid: 'Ekleyen Kullanıcı Guid',
    insertDatetime: 'Eklenme Tarihi',

    // Stock Status
    createNewStock: 'Yeni Stok Durumu Oluştur',
    editStockStatus: 'Stok Durumunu Düzenle',
    deleteStockStatus: 'Stok Durumunu Sil',
    updateStockStatus: 'Stok Durumunu Güncelle',
    createStockStatus: 'Stok Durumu Oluştur',
    stockStatusName: 'Stok Durumu Adı',
    stockStatusDescription: 'Stok Durumu Açıklaması',
    enterStockStatusName: 'Stok durumu Adını Girin',
    enterStockStatusDescription: 'Stok durumu açıklamasını girin',
    stockStatusNameRequired: 'Stok durumu adı zorunludur',
    stockStatusDescriptionRequired: 'Stok durumu açıklaması zorunludur',
    stockStatusCreated: 'Stok durumu başarıyla oluşturuldu',
    stockStatusUpdated: 'Stok durumu başarıyla güncellendi',
    stockStatusDeleted: 'Stok durumu başarıyla silindi',

    // Shipment Status
    'Shipment Status': 'Sevkiyat Durumu',
    'shipmentStatusName': 'Sevkiyat Durumu Adı',
    'shipmentStatusDescription': 'Sevkiyat Durumu Açıklaması',
    'enterShipmentStatusName': 'Sevkiyat Durumu Adı Girin',
    'enterShipmentStatusDescription': 'Sevkiyat Durumu Açıklaması Girin',
    'shipmentStatusNameRequired': 'Sevkiyat Durumu Adı zorunludur',
    'shipmentStatusDescriptionRequired': 'Sevkiyat Durumu Açıklaması zorunludur',
    'shipmentStatusCreated': 'Sevkiyat Durumu başarıyla oluşturuldu',
    'shipmentStatusUpdated': 'Sevkiyat Durumu başarıyla güncellendi',
    'shipmentStatusDeleted': 'Sevkiyat Durumu başarıyla silindi',
    'createShipmentStatus': 'Sevkiyat Durumu Oluştur',
    'updateShipmentStatus': 'Sevkiyat Durumu Güncelle',
    'deleteShipmentStatus': 'Sevkiyat Durumu Sil',
    'confirmDeleteShipmentStatus': 'Bu sevkiyat durumunu silmek istediğinizden emin misiniz?',

    // Error Messages
    somethingWentWrong: 'Bir şeyler yanlış gitti',
    sessionExpired: 'Oturum süresi doldu. Lütfen tekrar giriş yapın.',
    userSessionNotFound: 'Kullanıcı oturumu bulunamadı. Lütfen tekrar giriş yapın.',
    pageNotFound: 'Sayfa bulunamadı',

    // Breadcrumbs
    backToOrders: 'Siparişlere Geri Dön',
    backToStock: 'Stoklara Geri Dön',
    backToShipment: 'Sevkiyata Geri Dön',

    // Table Common
    showing: 'Gösteriliyor',
    to: 'ile',
    of: 'arası toplam',
    id: 'ID',
    orderNo: 'Sipariş No',
    generatingOrderNo: 'Sipariş No Oluşturuluyor...',
    name: 'Ad',
    editItem: 'Düzenle',
    deleteItem: 'Sil',
    confirmDelete: 'Silmeyi Onayla',
    confirmDeleteMessage: 'Bu öğeyi silmek istediğinizden emin misiniz?',

    // Common Form Labels
    nameRequired: 'Ad alanı zorunludur',
    descriptionRequired: 'Açıklama alanı zorunludur',
    enterName: 'Ad giriniz',
    enterDescription: 'Açıklama giriniz',

    // Status Messages
    itemCreated: 'Öğe başarıyla oluşturuldu',
    itemUpdated: 'Öğe başarıyla güncellendi',
    itemDeleted: 'Öğe başarıyla silindi',

    // Material
    materials: 'Materyaller',
    createMaterial: 'Materyal Oluştur',
    updateMaterial: 'Materyal Güncelle',
    materialName: 'Materyal Adı',
    materialProperties: 'Materyal Özelliği',
    materialDescription: 'Materyal Açıklaması',
    enterMaterialName: 'Materyal Adını Girin',
    enterMaterialDescription: 'Materyal açıklamasını girin',
    materialNameRequired: 'Materyal adı zorunludur',
    materialDescriptionRequired: 'Materyal açıklaması zorunludur',
    materialCreated: 'Materyal başarıyla oluşturuldu',
    materialUpdated: 'Materyal başarıyla güncellendi',
    materialDeleted: 'Materyal başarıyla silindi',

    // Yarn
    yarns: 'Örgü İplikler',
    createYarn: 'Örgü İplik Oluştur',
    updateYarn: 'Örgü İplik Güncelle',
    yarnCode: 'İplik Numarası',
    yarnName: 'İplik Kalitesi',
    yarnType: 'İplik Tipi',
    yarnTypeNe: 'Ne (Numara İngiliz)',
    yarnTypeNm: 'Nm (Numara Metrik)',
    yarnTypeDny: 'Dny (Denye)',
    yarnTypeNeDesc: 'Pamuk-tencel-viskon gibi iplikler için (4/1ne, 120/1ne)',
    yarnTypeNmDesc: 'Keten iplikler için (13 nm, 39 nm)',
    yarnTypeDnyDesc: 'Polyester-Nylon iplikler için (150/288/40, 40/34/20)',
    sampleFormats: 'Örnek Formatlar',
    sampleFormatNe: '8/1 (Ne için)',
    sampleFormatNm: '13 nm (Nm için)',
    sampleFormatDny: '150/288/40 (Dny için)',
    yarnFactor: 'İplik Çarpanı',
    yarnDescription: 'Örgü İplik Açıklaması',
    enterYarnCode: 'İplik numarasını girin',
    enterYarnName: 'İplik kalitesini girin',
    selectYarnType: 'İplik tipini seçin',
    enterYarnDescription: 'Örgü iplik açıklamasını girin',
    yarnCodeRequired: 'İplik numarası zorunludur',
    yarnNameRequired: 'İplik kalitesi zorunludur',
    yarnTypeRequired: 'İplik tipi zorunludur',
    yarnDescriptionRequired: 'Örgü iplik açıklaması zorunludur',
    yarnCreated: 'Örgü iplik başarıyla oluşturuldu',
    yarnUpdated: 'Örgü iplik başarıyla güncellendi',
    yarnDeleted: 'Örgü iplik başarıyla silindi',
    updateYarn: 'Örgü İplik Güncelle',
    deleteYarn: 'Örgü İplik Sil',
    confirmDeleteYarn: 'Bu örgü ipliği silmek istediğinizden emin misiniz?',
    createNewYarn: 'Yeni Örgü İplik Oluştur',
    stockStartDate: 'Stok Başlangıç Tarihi',
    stockEndDate: 'Stok Bitiş Tarihi',

    // Thread
    threadType: 'İplik Tipi',
    threadCount: 'İplik adedi',
    specification: 'Özellikler',
    threads: 'Dikiş İplikler',
    createThread: 'Dikiş İplik Oluştur',
    updateThread: 'Dikiş İplik Güncelle',
    threadName: 'Dikiş İplik Adı',
    threadDescription: 'Dikiş İplik Açıklaması',
    enterThreadName: 'Dikiş iplik Adını Girin',
    enterThreadDescription: 'Dikiş iplik açıklamasını girin',
    threadNameRequired: 'Dikiş iplik adı zorunludur',
    threadDescriptionRequired: 'Dikiş iplik açıklaması zorunludur',
    threadCreated: 'Dikiş iplik başarıyla oluşturuldu',
    threadUpdated: 'Dikiş iplik başarıyla güncellendi',
    threadDeleted: 'Dikiş iplik başarıyla silindi',

    // Weave
    createWeave: 'Tip Kodlama Oluştur',
    updateWeave: 'Tip Kodlama Güncelle',
    weaveName: 'Tip Kodlama Adı',
    weaveDescription: 'Tip Kodlama Açıklaması',
    enterWeaveName: 'Tip Kodlama Adını Girin',
    enterWeaveDescription: 'Tip Kodlama açıklamasını girin',
    weaveNameRequired: 'Tip Kodlama adı zorunludur',
    weaveDescriptionRequired: 'Tip Kodlama açıklaması zorunludur',
    weaveCreated: 'Tip Kodlama başarıyla oluşturuldu',
    weaveUpdated: 'Tip Kodlama başarıyla güncellendi',
    weaveDeleted: 'Tip Kodlama başarıyla silindi',


    // Color
    colors: 'Renkler',
    createColor: 'Renk Oluştur',
    updateColor: 'Renk Güncelle',
    colorName: 'Renk Adı',
    colorCode: 'Renk Kodu',
    colorDescription: 'Renk Açıklaması',
    enterColorName: 'Renk Adını Girin',
    enterColorCode: 'Renk Kodunu Girin',
    enterColorDescription: 'Renk açıklamasını girin',
    colorNameRequired: 'Renk adı zorunludur',
    colorCodeRequired: 'Renk kodu zorunludur',
    colorDescriptionRequired: 'Renk açıklaması zorunludur',
    colorCreated: 'Renk başarıyla oluşturuldu',
    colorUpdated: 'Renk başarıyla güncellendi',
    colorDeleted: 'Renk başarıyla silindi',

    // Unit
    units: 'Birimler',
    createUnit: 'Birim Oluştur',
    updateUnit: 'Birim Güncelle',
    unitName: 'Birim Adı',
    unitDescription: 'Birim Açıklaması',
    enterUnitName: 'Birim Adını Girin',
    enterUnitDescription: 'Birim açıklamasını girin',
    unitNameRequired: 'Birim adı zorunludur',
    unitDescriptionRequired: 'Birim açıklaması zorunludur',
    unitCreated: 'Birim başarıyla oluşturuldu',
    unitUpdated: 'Birim başarıyla güncellendi',
    unitDeleted: 'Birim başarıyla silindi',

    // Composition
    compositions: 'Kompozisyonlar',
    createComposition: 'Kompozisyon Oluştur',
    updateComposition: 'Kompozisyon Güncelle',
    deleteComposition: 'Kompozisyon Sil',
    compositionName: 'Kompozisyon Adı',
    compositionDescription: 'Kompozisyon Açıklaması',
    enterCompositionName: 'Kompozisyon Adını Girin',
    enterCompositionDescription: 'Kompozisyon açıklamasını girin',
    compositionNameRequired: 'Kompozisyon adı zorunludur',
    compositionDescriptionRequired: 'Kompozisyon açıklaması zorunludur',
    compositionCreated: 'Kompozisyon başarıyla oluşturuldu',
    compositionUpdated: 'Kompozisyon başarıyla güncellendi',
    compositionDeleted: 'Kompozisyon başarıyla silindi',
    // Composition specific translations for weaving thread
    threadName: 'Dokuma İplik Adı',
    threadDescription: 'Dokuma İplik Açıklaması',
    enterThreadName: 'Dokuma iplik adını girin',
    enterThreadDescription: 'Dokuma iplik açıklamasını girin',
    threadCompositionDescription: 'Karışım Açıklaması',
    enterThreadCompositionDescription: 'Karışım açıklamasını girin',
    threadNameRequired: 'Dokuma iplik adı zorunludur',
    threadDescriptionRequired: 'Dokuma iplik açıklaması zorunludur',
    confirmDeleteComposition: 'Bu kompozisyonu silmek istediğinizden emin misiniz?',
    confirmDeleteCompositionStatus: 'Bu kompozisyonu silmek istediğinizden emin misiniz?',

    // Weave Color
    weaveColors: 'Dokuma Renkleri',
    createWeaveColor: 'Dokuma Rengi Oluştur',
    updateWeaveColor: 'Dokuma Rengi Güncelle',
    weaveColorName: 'Dokuma Rengi Adı',
    weaveColorDescription: 'Dokuma Rengi Açıklaması',
    enterWeaveColorName: 'Dokuma rengi Adını Girin',
    enterWeaveColorDescription: 'Dokuma rengi açıklamasını girin',
    weaveColorNameRequired: 'Dokuma rengi adı zorunludur',
    weaveColorDescriptionRequired: 'Dokuma rengi açıklaması zorunludur',
    weaveColorCreated: 'Dokuma rengi başarıyla oluşturuldu',
    weaveColorUpdated: 'Dokuma rengi başarıyla güncellendi',
    weaveColorDeleted: 'Dokuma rengi başarıyla silindi',

    // Currency
    currencies: 'Para Birimleri',
    createCurrency: 'Para Birimi Oluştur',
    updateCurrency: 'Para Birimi Güncelle',
    currencyName: 'Para Birimi Adı',
    currencyDescription: 'Para Birimi Açıklaması',
    enterCurrencyName: 'Para birimi Adını Girin',
    enterCurrencyDescription: 'Para birimi açıklamasını girin',
    currencyNameRequired: 'Para birimi adı zorunludur',
    currencyDescriptionRequired: 'Para birimi açıklaması zorunludur',
    currencyCreated: 'Para birimi başarıyla oluşturuldu',
    currencyUpdated: 'Para birimi başarıyla güncellendi',
    currencyDeleted: 'Para birimi başarıyla silindi',

    // Weave Type
    weaveTypes: 'Dokuma Tipleri',
    createWeaveType: 'Dokuma Tipi Oluştur',
    updateWeaveType: 'Dokuma Tipi Güncelle',
    weaveTypeName: 'Dokuma Tipi Adı',
    weaveTypeDescription: 'Dokuma Tipi Açıklaması',
    enterWeaveTypeName: 'Dokuma tipi Adını Girin',
    enterWeaveTypeDescription: 'Dokuma tipi açıklamasını girin',
    weaveTypeNameRequired: 'Dokuma tipi adı zorunludur',
    weaveTypeDescriptionRequired: 'Dokuma tipi açıklaması zorunludur',
    weaveTypeCreated: 'Dokuma tipi başarıyla oluşturuldu',
    weaveTypeUpdated: 'Dokuma tipi başarıyla güncellendi',
    weaveTypeDeleted: 'Dokuma tipi başarıyla silindi',

    // Supplier Type
    supplierTypes: 'Tedarikçi Tipleri',
    supplierType: 'Tedarikçi Tipi',
    createSupplierType: 'Tedarikçi Tipi Oluştur',
    updateSupplierType: 'Tedarikçi Tipi Güncelle',
    supplierTypeName: 'Tedarikçi Tipi Adı',
    supplierTypeDescription: 'Tedarikçi Tipi Açıklaması',
    enterSupplierTypeName: 'Tedarikçi tipi adını girin',
    enterSupplierTypeDescription: 'Tedarikçi tipi açıklamasını girin',
    supplierTypeNameRequired: 'Tedarikçi tipi adı zorunludur',
    supplierTypeDescriptionRequired: 'Tedarikçi tipi açıklaması zorunludur',
    supplierTypeCreated: 'Tedarikçi tipi başarıyla oluşturuldu',
    supplierTypeUpdated: 'Tedarikçi tipi başarıyla güncellendi',
    supplierTypeDeleted: 'Tedarikçi tipi başarıyla silindi',


    // Pagination
    paginationInfo: 'Toplam {{total}} kayıttan {{start}} - {{end}} arası gösteriliyor',

    // Stock
    'Stock Status': 'Stok Durumu',
    'Create New Stock': 'Create New Stock Status',
    'Stock List': 'Stok Listesi',
    'Stock Details': 'Stok Detayları',
    'Stock Information': 'Stok Bilgileri',
    'Stock Code': 'Stok Kodu',
    'Stock Name': 'Stok Adı',
    'Stock Type': 'Stok Tipi',
    'Stock Quantity': 'Stok Miktarı',
    'Stock Unit': 'Stok Birimi',
    'Stock Location': 'Stok Konumu',
    'Stock Notes': 'Stok Notları',
    'Enter Stock Code': 'Stok Kodu Girin',
    'Enter Stock Name': 'Stok Adı Girin',
    'Enter Stock Type': 'Stok Tipi Girin',
    'Enter Stock Quantity': 'Stok Miktarı Girin',
    'Enter Stock Location': 'Stok Konumu Girin',
    'Enter Stock Notes': 'Stok Notları Girin',
    'Stock Code Required': 'Stok Kodu zorunludur',
    'Stock Name Required': 'Stok Adı zorunludur',
    'Stock Type Required': 'Stok Tipi zorunludur',
    'Stock Quantity Required': 'Stok Miktarı zorunludur',
    'Stock Unit Required': 'Stok Birimi zorunludur',
    'Stock Location Required': 'Stok Konumu zorunludur',

    // Shipment
    'Shipment List': 'Sevkiyat Listesi',
    'Shipment Details': 'Sevkiyat Detayları',
    'Shipment Information': 'Sevkiyat Bilgileri',
    'Shipment Code': 'Sevkiyat Kodu',
    'Shipment Date': 'Sevkiyat Tarihi',
    'Shipment Type': 'Sevkiyat Tipi',
    'Shipment Method': 'Sevkiyat Yöntemi',
    'Shipment Carrier': 'Sevkiyat Taşıyıcısı',
    'Tracking Number': 'Takip Numarası',
    'Shipment Notes': 'Sevkiyat Notları',
    'Enter Shipment Code': 'Sevkiyat Kodu Girin',
    'Enter Tracking Number': 'Takip Numarası Girin',
    'Enter Shipment Notes': 'Sevkiyat Notları Girin',
    'Select Shipment Date': 'Sevkiyat Tarihi Seçin',
    'Select Shipment Type': 'Sevkiyat Tipi Seçin',
    'Select Shipment Method': 'Sevkiyat Yöntemi Seçin',
    'Select Shipment Carrier': 'Sevkiyat Taşıyıcısı Seçin',
    'Shipment Code Required': 'Sevkiyat Kodu zorunludur',
    'Shipment Date Required': 'Sevkiyat Tarihi zorunludur',
    'Shipment Type Required': 'Sevkiyat Tipi zorunludur',
    'Shipment Method Required': 'Sevkiyat Yöntemi zorunludur',
    'Shipment Carrier Required': 'Sevkiyat Taşıyıcısı zorunludur',
    'Tracking Number Required': 'Takip Numarası zorunludur',

    // Additional Material translations
    'Material List': 'Materyal Listesi',
    'Material Details': 'Materyal Detayları',
    'Material Information': 'Materyal Bilgileri',
    'Material Code': 'Materyal Kodu',
    'Material Type': 'Materyal Tipi',
    'Material Properties': 'Materyal Özellikleri',
    'Material Supplier': 'Materyal Tedarikçisi',
    'Enter Material Code': 'Materyal Kodu Girin',
    'Enter Material Type': 'Materyal Tipi Girin',
    'Enter Material Properties': 'Materyal Özelliklerini Girin',
    'Select Material Supplier': 'Materyal Tedarikçisi Seçin',
    'Material Code Required': 'Materyal Kodu zorunludur',
    'Material Type Required': 'Materyal Tipi zorunludur',
    'Material Properties Required': 'Materyal Özellikleri zorunludur',
    'Material Supplier Required': 'Materyal Tedarikçisi zorunludur',

    // Additional Yarn translations
    'Yarn List': 'Örgü İplik Listesi',
    'Yarn Details': 'Örgü İplik Detayları',
    'Yarn Information': 'Örgü İplik Bilgileri',
    'Yarn Code': 'Örgü İplik Kodu',
    'Yarn Type': 'Örgü İplik Tipi',
    'Yarn Color': 'Örgü İplik Rengi',
    'Yarn Weight': 'Örgü İplik Ağırlığı',
    'Yarn Properties': 'Örgü İplik Özellikleri',
    'Yarn Supplier': 'Örgü İplik Tedarikçisi',
    'Enter Yarn Code': 'Örgü İplik Kodu Girin',
    'Enter Yarn Type': 'Örgü İplik Tipi Girin',
    'Enter Yarn Color': 'Örgü İplik Rengi Girin',
    'Enter Yarn Weight': 'Örgü İplik Ağırlığı Girin',
    'Enter Yarn Properties': 'Örgü İplik Özelliklerini Girin',
    'Select Yarn Supplier': 'Örgü İplik Tedarikçisi Seçin',
    'Yarn Code Required': 'Örgü İplik Kodu zorunludur',
    'Yarn Type Required': 'Örgü İplik Tipi zorunludur',
    'Yarn Color Required': 'Örgü İplik Rengi zorunludur',
    'Yarn Weight Required': 'Örgü İplik Ağırlığı zorunludur',
    'Yarn Properties Required': 'Örgü İplik Özellikleri zorunludur',
    'Yarn Supplier Required': 'Örgü İplik Tedarikçisi zorunludur',

    // Delete Modal
    'Confirm Delete': 'Silmeyi Onayla',
    'Are you sure you want to delete this stock status?': 'Bu stok durumunu silmek istediğinizden emin misiniz?',
    'This action cannot be undone.': 'Bu işlem geri alınamaz.',
    'Edit Stock Status': 'Stok Durumunu Düzenle',
    'Delete Stock Status': 'Stok Durumunu Sil',
    'No data found.': 'Veri bulunamadı.',
    'Loading data...': 'Veriler yükleniyor...',
    'Cancel': 'İptal',
    'Delete': 'Sil',

    // Material Status
    'Material Status': 'Materyal Durumu',
    'materialStatusName': 'Materyal Durumu Adı',
    'materialStatusDescription': 'Materyal Durumu Açıklaması',
    'enterMaterialStatusName': 'Enter Material Status Name',
    'enterMaterialStatusDescription': 'Enter Material Status Description',
    'materialStatusNameRequired': 'Materyal Durumu Adı zorunludur',
    'materialStatusDescriptionRequired': 'Materyal Durumu Açıklaması zorunludur',
    'materialStatusCreated': 'Materyal durumu başarıyla oluşturuldu',
    'materialStatusUpdated': 'Materyal durumu başarıyla güncellendi',
    'materialStatusDeleted': 'Materyal durumu başarıyla silindi',
    'createMaterialStatus': 'Create Material Status',
    'updateMaterialStatus': 'Materyal Durumu Güncelle',
    'deleteMaterialStatus': 'Materyal Durumu Sil',
    'confirmDeleteMaterialStatus': 'Bu materyal durumunu silmek istediğinizden emin misiniz?',

    // Yarn Status
    'Yarn Status': 'Örgü İplik Durumu',
    'yarnStatusName': 'Örgü İplik Durumu Adı',
    'yarnStatusDescription': 'Örgü İplik Durumu Açıklaması',
    'enterYarnStatusName': 'Örgü İplik Durumu Adı Girin',
    'enterYarnStatusDescription': 'Örgü İplik Durumu Açıklaması Girin',
    'yarnStatusNameRequired': 'Örgü İplik Durumu Adı zorunludur',
    'yarnStatusDescriptionRequired': 'Örgü İplik Durumu Açıklaması zorunludur',
    'yarnStatusCreated': 'Örgü iplik durumu başarıyla oluşturuldu',
    'yarnStatusUpdated': 'Örgü iplik durumu başarıyla güncellendi',
    'yarnStatusDeleted': 'Örgü iplik durumu başarıyla silindi',
    'createYarnStatus': 'Create Yarn Status',
    'updateYarnStatus': 'Örgü İplik Durumu Güncelle',
    'deleteYarnStatus': 'Örgü İplik Durumu Sil',
    'confirmDeleteYarnStatus': 'Bu örgü iplik durumunu silmek istediğinizden emin misiniz?',

    // Thread Status
    'Thread Status': 'Dikiş İplik Durumu',
    'threadStatusName': 'Dikiş İplik Durumu Adı',
    'threadStatusDescription': 'Dikiş İplik Durumu Açıklaması',
    'enterThreadStatusName': 'Enter Thread Status Name',
    'enterThreadStatusDescription': 'Enter Thread Status Description',
    'threadStatusNameRequired': 'Dikiş İplik Durumu Adı zorunludur',
    'threadStatusDescriptionRequired': 'Dikiş İplik Durumu Açıklaması zorunludur',
    'threadStatusCreated': 'Dikiş iplik durumu başarıyla oluşturuldu',
    'threadStatusUpdated': 'Dikiş iplik durumu başarıyla güncellendi',
    'threadStatusDeleted': 'Dikiş iplik durumu başarıyla silindi',
    'createThreadStatus': 'Create Thread Status',
    'updateThreadStatus': 'Dikiş İplik Durumu Güncelle',
    'deleteThreadStatus': 'Dikiş İplik Durumu Sil',
    'confirmDeleteThreadStatus': 'Bu dikiş iplik durumunu silmek istediğinizden emin misiniz?',

    // Weave Status
    'Weave Status': 'Dokuma Durumu',
    'weaveStatusName': 'Dokuma Durumu Adı',
    'weaveStatusDescription': 'Dokuma Durumu Açıklaması',
    'enterWeaveStatusName': 'Enter Weave Status Name',
    'enterWeaveStatusDescription': 'Enter Weave Status Description',
    'weaveStatusNameRequired': 'Dokuma Durumu Adı zorunludur',
    'weaveStatusDescriptionRequired': 'Dokuma Durumu Açıklaması zorunludur',
    'weaveStatusCreated': 'Dokuma durumu başarıyla oluşturuldu',
    'weaveStatusUpdated': 'Dokuma durumu başarıyla güncellendi',
    'weaveStatusDeleted': 'Dokuma durumu başarıyla silindi',
    'createWeaveStatus': 'Create Weave Status',
    'updateWeaveStatus': 'Update Weave Status',
    'deleteWeaveStatus': 'Delete Weave Status',
    'confirmDeleteWeaveStatus': 'Bu dokumayı silmek istediğinizden emin misiniz?',

    // Color Status
    'Color Status': 'Renk Durumu',
    'colorStatusName': 'Renk Durumu Adı',
    'colorStatusDescription': 'Renk Durumu Açıklaması',
    'enterColorStatusName': 'Enter Color Status Name',
    'enterColorStatusDescription': 'Enter Color Status Description',
    'colorStatusNameRequired': 'Renk Durumu Adı zorunludur',
    'colorStatusDescriptionRequired': 'Renk Durumu Açıklaması zorunludur',
    'colorStatusCreated': 'Renk durumu başarıyla oluşturuldu',
    'colorStatusUpdated': 'Renk durumu başarıyla güncellendi',
    'colorStatusDeleted': 'Renk durumu başarıyla silindi',
    'createColorStatus': 'Create Color Status',
    'updateColorStatus': 'Update Color Status',
    'deleteColorStatus': 'Delete Color Status',
    'confirmDeleteColorStatus': 'Bu renk durumunu silmek istediğinizden emin misiniz?',

    // Unit Status
    'Unit Status': 'Birim Durumu',
    'unitStatusName': 'Birim Durumu Adı',
    'unitStatusDescription': 'Birim Durumu Açıklaması',
    'enterUnitStatusName': 'Enter Unit Status Name',
    'enterUnitStatusDescription': 'Enter Unit Status Description',
    'unitStatusNameRequired': 'Birim Durumu Adı zorunludur',
    'unitStatusDescriptionRequired': 'Birim Durumu Açıklaması zorunludur',
    'unitStatusCreated': 'Birim durumu başarıyla oluşturuldu',
    'unitStatusUpdated': 'Birim durumu başarıyla güncellendi',
    'unitStatusDeleted': 'Birim durumu başarıyla silindi',
    'createUnitStatus': 'Create Unit Status',
    'updateUnitStatus': 'Update Unit Status',
    'deleteUnitStatus': 'Delete Unit Status',
    'confirmDeleteUnitStatus': 'Bu birim durumunu silmek istediğinizden emin misiniz?',

    // Composition Status
    'Composition Status': 'Kompozisyon Durumu',
    'compositionStatusName': 'Kompozisyon Durumu Adı',
    'compositionStatusDescription': 'Kompozisyon Durumu Açıklaması',
    'enterCompositionStatusName': 'Enter Composition Status Name',
    'enterCompositionStatusDescription': 'Enter Composition Status Description',
    'compositionStatusNameRequired': 'Kompozisyon Durumu Adı zorunludur',
    'compositionStatusDescriptionRequired': 'Kompozisyon Durumu Açıklaması zorunludur',
    'compositionStatusCreated': 'Kompozisyon durumu başarıyla oluşturuldu',
    'compositionStatusUpdated': 'Kompozisyon durumu başarıyla güncellendi',
    'compositionStatusDeleted': 'Kompozisyon durumu başarıyla silindi',
    'createCompositionStatus': 'Create Composition Status',
    'updateCompositionStatus': 'Update Composition Status',
    'deleteCompositionStatus': 'Delete Composition Status',
    'confirmDeleteCompositionStatus': 'Bu kompozisyon durumunu silmek istediğinizden emin misiniz?',

    // Weave Color Status
    'Weave Color Status': 'Dokuma Renk Durumu',
    'weaveColorStatusName': 'Dokuma Renk Durumu Adı',
    'weaveColorStatusDescription': 'Dokuma Renk Durumu Açıklaması',
    'enterWeaveColorStatusName': 'Enter Weave Color Status Name',
    'enterWeaveColorStatusDescription': 'Enter Weave Color Status Description',
    'weaveColorStatusNameRequired': 'Dokuma Renk Durumu Adı zorunludur',
    'weaveColorStatusDescriptionRequired': 'Dokuma Renk Durumu Açıklaması zorunludur',
    'weaveColorStatusCreated': 'Dokuma renk durumu başarıyla oluşturuldu',
    'weaveColorStatusUpdated': 'Dokuma renk durumu başarıyla güncellendi',
    'weaveColorStatusDeleted': 'Dokuma renk durumu başarıyla silindi',
    'createWeaveColorStatus': 'Create Weave Color Status',
    'updateWeaveColorStatus': 'Update Weave Color Status',
    'deleteWeaveColorStatus': 'Delete Weave Color Status',
    'confirmDeleteWeaveColorStatus': 'Bu dokuma renk durumunu silmek istediğinizden emin misiniz?',

    // Currency Status
    'Currency Status': 'Para Birimi Durumu',
    'currencyStatusName': 'Para Birimi Durumu Adı',
    'currencyStatusDescription': 'Para Birimi Durumu Açıklaması',
    'enterCurrencyStatusName': 'Enter Currency Status Name',
    'enterCurrencyStatusDescription': 'Enter Currency Status Description',
    'currencyStatusNameRequired': 'Para Birimi Durumu Adı zorunludur',
    'currencyStatusDescriptionRequired': 'Para Birimi Durumu Açıklaması zorunludur',
    'currencyStatusCreated': 'Para birimi durumu başarıyla oluşturuldu',
    'currencyStatusUpdated': 'Para birimi durumu başarıyla güncellendi',
    'currencyStatusDeleted': 'Para birimi durumu başarıyla silindi',
    'createCurrencyStatus': 'Create Currency Status',
    'updateCurrencyStatus': 'Update Currency Status',
    'deleteCurrencyStatus': 'Delete Currency Status',
    'confirmDeleteCurrencyStatus': 'Bu para birimini silmek istediğinizden emin misiniz?',

    // Weave Type Status
    'Weave Type Status': 'Dokuma Tipi Durumu',
    'weaveTypeStatusName': 'Dokuma Tipi Durumu Adı',
    'weaveTypeStatusDescription': 'Dokuma Tipi Durumu Açıklaması',
    'enterWeaveTypeStatusName': 'Enter Weave Type Status Name',
    'enterWeaveTypeStatusDescription': 'Enter Weave Type Status Description',
    'weaveTypeStatusNameRequired': 'Dokuma Tipi Durumu Adı zorunludur',
    'weaveTypeStatusDescriptionRequired': 'Dokuma Tipi Durumu Açıklaması zorunludur',
    'weaveTypeStatusCreated': 'Dokuma tipi durumu başarıyla oluşturuldu',
    'weaveTypeStatusUpdated': 'Dokuma tipi durumu başarıyla güncellendi',
    'weaveTypeStatusDeleted': 'Dokuma tipi durumu başarıyla silindi',
    'createWeaveTypeStatus': 'Create Weave Type Status',
    'updateWeaveTypeStatus': 'Update Weave Type Status',
    'deleteWeaveTypeStatus': 'Delete Weave Type Status',
    'confirmDeleteWeaveTypeStatus': 'Bu dokuma tipini silmek istediğinizden emin misiniz?',

    // Common
    'Status ID': 'Durum ID',
    'Status Name': 'Durum Adı',
    'Description': 'Açıklama',
    'Actions': 'İşlemler',
    'Save': 'Kaydet',
    'Cancel': 'İptal',
    'Delete': 'Sil',
    'Edit': 'Düzenle',
    'Saving': 'Kaydediliyor...',
    'Creating': 'Oluşturuluyor...',
    'Updating': 'Güncelleniyor...',
    'Deleting': 'Siliniyor...',

    // Weave Table Specific
    weaveCode: 'Dokuma Kodu',
    weaveCodeTip: 'Tip Kodu',
    warpYarn: 'Çözgü İpliği',
    weftYarn: 'Atkı İpliği',
    warpDensity: 'Çözgü Sıklığı',
    weftDensity: 'Atkı Sıklığı',
    reedWidth: 'Tarak Eni',
    totalThreads: 'Toplam Tel Sayısı',
    yarnCode: 'İplik Kodu',
    weftYarnCode: 'Atkı İplik Kodu',
    yarnNumber: 'İplik',
    weftYarnName: 'Atkı İplik Adı',
    warpWeight: 'Çözgü Gramajı',
    waftWeight: 'Çözgü Gramajı',
    show: 'Göster',
    entries: 'kayıt',
    paginationInfo: 'Toplam {{total}} kayıttan {{start}} - {{end}} arası gösteriliyor',
    filters: 'Filtreler',
    clearFilters: 'Filtreleri Temizle',
    search: 'Ara',
    resultsFound: 'sonuç bulundu',
    totalRecords: 'toplam kayıt',
    noResultsFound: 'Arama kriterlerinize uygun sonuç bulunamadı',
    clearFiltersToSeeAll: 'Tüm kayıtları görmek için filtreleri temizleyin',
    fabricWidth: 'Mamül Kumaş Eni',
    fabricWeight: 'Mamül Kumaş Gramajı',
    grayFabricWidth: 'Ham Kumaş Eni',
    grayFabricWeight: 'Ham Kumaş Gramajı',

    // --- WEAVE INPUTS TABLOSU İÇİN EKLENDİ ---
    colorName: 'Renk Adı',
    colorNumber: 'Renk Numarası',
    total: 'Toplam',
    percent: '%',
    action: 'İşlem',
    rows: 'Satır',
    columns: 'Sütun',
    addRow: 'Satır Ekle',
    addColumn: 'Sütun Ekle',
    removeColumn: 'Sütun Sil',
    removeRow: 'Satırı Sil',
    selectColor: 'Renk Seçin',
    warpColorReport: 'ÇÖZGÜ RENK RAPORU',
    weftColorReport: 'ATKI RENK RAPORU',
    totalLabel: 'TOPLAM:',
    successfullySaved: 'Başarıyla kaydedildi!',

    // Common Actions and Labels
    actions: 'İşlemler',
    id: 'ID',
    description: 'Açıklama',
    cancel: 'İptal',
    delete: 'Sil',

    // Weave Status Actions
    updateWeaveStatus: 'Dokuma Güncelle',
    deleteWeaveStatus: 'Dokuma Sil',
    confirmDeleteWeaveStatus: 'Bu dokumayı silmek istediğinizden emin misiniz?',

    userManagement: 'Kullanıcı Yönetimi',
    userList: 'Kullanıcı Listesi',
    createUser: 'Kullanıcı Oluştur',
    updateUser: 'Kullanıcı Güncelle',
    deleteUser: 'Kullanıcı Sil',
    editUser: 'Kullanıcı Düzenle',
    userDetails: 'Kullanıcı Detayları',
    userInformation: 'Kullanıcı Bilgileri',

    // User Fields
    userId: 'Kullanıcı ID',
    userName: 'Kullanıcı Adı',
    userEmail: 'E-posta',
    userFullName: 'Ad Soyad',
    surname: 'Soyad',
    mobilePhone: 'Mobil Telefon',
    userPhone: 'Telefon',
    userRole: 'Rol',
    userDepartment: 'Departman',
    userStatus: 'Durum',
    userCreatedDate: 'Oluşturulma Tarihi',
    userLastLogin: 'Son Giriş',

    // User Form Fields
    enterUserName: 'Kullanıcı adını girin',
    enterUserEmail: 'E-posta adresini girin',
    enterUserFullName: 'Ad soyadını girin',
    enterSurname: 'Soyad girin',
    enterMobilePhone: 'Mobil telefon numarasını girin',
    enterUserPhone: 'Telefon numarasını girin',
    enterStockStartDate: 'Stok Başlangıç Tarihi',
    enterStockEndDate: 'Stok Bitiş Tarihi',
    selectUserRole: 'Kullanıcı rolü seçin',
    selectUserDepartment: 'Departman seçin',
    selectUserStatus: 'Durum seçin',

    // User Validation
    userNameRequired: 'Kullanıcı adı zorunludur',
    userEmailRequired: 'E-posta zorunludur',
    userFullNameRequired: 'Ad soyad zorunludur',
    surnameRequired: 'Soyad zorunludur',
    mobilePhoneRequired: 'Mobil telefon numarası zorunludur',
    userPhoneRequired: 'Telefon numarası zorunludur',
    userRoleRequired: 'Kullanıcı rolü zorunludur',
    userDepartmentRequired: 'Departman zorunludur',
    userStatusRequired: 'Kullanıcı durumu zorunludur',
    invalidEmailFormat: 'Geçersiz e-posta formatı',
    invalidPhoneFormat: 'Geçersiz telefon formatı',

    // User Messages
    userCreated: 'Kullanıcı başarıyla oluşturuldu',
    userUpdated: 'Kullanıcı başarıyla güncellendi',
    userDeleted: 'Kullanıcı başarıyla silindi',
    confirmDeleteUser: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
    userDeleteWarning: 'Bu işlem kullanıcı hesabını kalıcı olarak silecek ve geri alınamaz.',

    // User Roles
    admin: 'Yönetici',
    manager: 'Müdür',
    employee: 'Çalışan',
    viewer: 'Görüntüleyici',

    // User Departments
    production: 'Üretim',
    sales: 'Satış',
    accounting: 'Muhasebe',
    hr: 'İnsan Kaynakları',
    it: 'Bilgi İşlem',

    // User Status
    activeUser: 'Aktif',
    inactiveUser: 'Pasif',
    suspendedUser: 'Askıya Alınmış',
    pendingUser: 'Beklemede',

    // User Actions
    createNewUser: 'Yeni Kullanıcı Oluştur',
    viewUserProfile: 'Profili Görüntüle',
    resetPassword: 'Şifre Sıfırla',
    changeUserStatus: 'Durum Değiştir',
    userPermissions: 'Kullanıcı İzinleri',

    // Password Reset
    resetUserPassword: 'Şifre Sıfırla',
    confirmResetPassword: 'Bu kullanıcının şifresini sıfırlamak istediğinizden emin misiniz?',
    // resetUserPasswordWarning: 'Yeni şifre kullanıcıya e-posta ile gönderilecektir.',
    passwordResetSuccess: 'Şifre Başarıyla Sıfırlandı!',
    passwordResetSuccessMessage: 'Kullanıcının şifresi başarıyla sıfırlandı.',
    passwordResetError: 'Şifre Sıfırlama Hatası!',
    passwordResetErrorMessage: 'Şifre sıfırlanırken bir hata oluştu.',
    activationCode: 'Aktivasyon Kodu',
    activationCodeNote: 'Bu aktivasyon kodunu güvenli bir yerde saklayın ve kullanıcıya iletin.',
    newPassword: 'Yeni Şifre',
    newPasswordNote: 'Bu şifreyi güvenli bir yerde saklayın ve kullanıcıya iletin.',
    close: 'Kapat',

    // Change Password
    changePassword: 'Şifre Değiştir',
    currentPassword: 'Mevcut Şifre',
    newPassword: 'Yeni Şifre',
    confirmNewPassword: 'Yeni Şifre (Tekrar)',
    enterCurrentPassword: 'Mevcut şifrenizi girin',
    enterNewPassword: 'Yeni şifrenizi girin',
    confirmNewPassword: 'Yeni şifrenizi tekrar girin',
    currentPasswordRequired: 'Mevcut şifre zorunludur',
    newPasswordRequired: 'Yeni şifre zorunludur',
    passwordTooShort: 'Şifre en az 4 karakter olmalıdır',
    passwordsNotMatch: 'Yeni şifreler eşleşmiyor',
    newPasswordSameAsCurrent: 'Yeni şifre mevcut şifre ile aynı olamaz',
    passwordChangedSuccessfully: 'Şifre başarıyla değiştirildi',
    passwordChangeError: 'Şifre değiştirme sırasında hata oluştu',
    passwordMinLength: 'Şifre en az 4 karakter olmalıdır',
    changing: 'Değiştiriliyor...',
    logout: 'Çıkış Yap',
    userSessionNotFound: 'Kullanıcı oturumu bulunamadı. Lütfen tekrar giriş yapın.',

    // Password Strength
    passwordStrength: 'Şifre Gücü',
    weakPassword: 'Zayıf',
    mediumPassword: 'Orta',
    strongPassword: 'Güçlü',
    veryStrongPassword: 'Çok Güçlü',
    passwordRequirements: 'En az 6 karakter, büyük/küçük harf, rakam ve özel karakter kullanın',
    passwordsMatch: 'Şifreler Eşleşti',

    // User Details
    viewUserDetails: 'Kullanıcı Detaylarını Görüntüle',
    userNotFound: 'Kullanıcı bulunamadı',
    goBack: 'Geri Dön',
    personalInfo: 'Kişisel Bilgiler',
    systemInfo: 'Sistem Bilgileri',
    generalInfo: 'Genel Bilgiler',
    firstName: 'Ad',
    lastName: 'Soyad',
    email: 'E-posta',
    phone: 'Telefon',
    lastLogin: 'Son Giriş',
    createdDate: 'Oluşturma Tarihi',
    updatedDate: 'Güncelleme Tarihi',
    status: 'Durum',
    justNow: 'Az Önce',
    minutesAgo: 'Dakika Önce',
    hoursAgo: 'Saat Önce',
    daysAgo: 'Gün Önce',
    monthsAgo: 'Ay Önce',
    yearsAgo: 'Yıl Önce',

    // Sessions Tab
    sessions: 'Oturumlar',
    sessionId: 'Oturum ID',
    expireTime: 'Bitiş Zamanı',
    jwt: 'JWT Token',
    noSessionsFound: 'Aktif oturum bulunamadı',

    // Password History Tab
    passwordHistory: 'Şifre Geçmişi',
    passwordId: 'Şifre ID',
    createdBy: 'Oluşturan',
    noPasswordHistoryFound: 'Şifre geçmişi bulunamadı',
    customerId: 'Müşteri ID',
    customerName: 'Müşteri Adı',
    customerDescription: 'Müşteri Açıklaması',
    address: 'Adres',
    contact: 'İrtibat',
    createCustomer: 'Müşteri Oluştur',
    updateCustomer: 'Müşteri Güncelle',
    deleteCustomer: 'Müşteri Sil',
    editCustomer: 'Müşteri Düzenle',
    customerCreated: 'Müşteri başarıyla oluşturuldu',
    customerUpdated: 'Müşteri başarıyla güncellendi',
    customerDeleted: 'Müşteri başarıyla silindi',
    confirmDeleteCustomer: 'Bu müşteriyi silmek istediğinizden emin misiniz?',
    customerDeleteWarning: 'Bu işlem müşteri kaydını kalıcı olarak silecek ve geri alınamaz.',
    enterCustomerName: 'Müşteri adını girin',
    enterCustomerDescription: 'Müşteri açıklamasını girin',
    enterAddress: 'Adres girin',
    enterCepTel: 'Mobil telefon girin',
    enterTelefon: 'Telefon girin',
    enterContact: 'İrtibat kişisi girin',
    enterEmail: 'E-posta adresini girin',
    customerNameRequired: 'Müşteri adı zorunludur',
    customerDescriptionRequired: 'Müşteri açıklaması zorunludur',
    addressRequired: 'Adres zorunludur',
    cepTelRequired: 'Mobil telefon zorunludur',
    telefonRequired: 'Telefon zorunludur',
    contactRequired: 'İrtibat zorunludur',
    suppliers: 'Tedarikçiler',
    supplierId: 'Tedarikçi ID',
    supplierName: 'Tedarikçi Adı',
    supplierDescription: 'Tedarikçi Açıklaması',
    createSupplier: 'Tedarikçi Oluştur',
    updateSupplier: 'Tedarikçi Güncelle',
    deleteSupplier: 'Tedarikçi Sil',
    editSupplier: 'Tedarikçi Düzenle',
    supplierCreated: 'Tedarikçi başarıyla oluşturuldu',
    supplierUpdated: 'Tedarikçi başarıyla güncellendi',
    supplierDeleted: 'Tedarikçi başarıyla silindi',
    confirmDeleteSupplier: 'Bu tedarikçiyi silmek istediğinizden emin misiniz?',
    supplierDeleteWarning: 'Bu işlem tedarikçi kaydını kalıcı olarak silecek ve geri alınamaz.',
    enterSupplierName: 'Tedarikçi adını girin',
    enterSupplierDescription: 'Tedarikçi açıklamasını girin',
    supplierNameRequired: 'Tedarikçi adı zorunludur',
    supplierDescriptionRequired: 'Tedarikçi açıklaması zorunludur',
    updateSample: 'Analiz Güncelle',
    enterWeaveCode: 'Tip Kodu Girin',
    createWeaveFromSampleDescription: 'Seçilen Analiz dokuma temel alınarak yeni bir dokuma ve ürün oluşturun',

    // Session ve Network Error Messages
    sessionExpired: 'Oturum süresi doldu. Lütfen tekrar giriş yapın.',
    networkErrorSessionTimeout: 'Sunucuya bağlanılamadı. Oturumunuz sonlandırılıyor.',
    unauthorizedError: 'Yetkiniz bulunmuyor. Lütfen tekrar giriş yapın.',
    accessDeniedError: 'Erişim reddedildi. Lütfen tekrar giriş yapın.',
    sessionError: 'Oturum hatası oluştu.',
    connectionError: 'Bağlantı Hatası!',
    networkError: 'Ağ Hatası!',
    connectionErrorMessage: 'Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.',
    sessionTimeoutTitle: 'Oturum Süresi Doldu!',
    sessionTimeoutMessage: 'Oturumunuzun süresi doldu. Giriş sayfasına yönlendiriliyorsunuz.',
    unexpectedError: 'Beklenmeyen Hata!',
    unexpectedErrorMessage: 'Beklenmeyen bir hata oluştu',

    // HTTP Error Messages
    httpError: 'HTTP Hatası',
    serverError: 'Sunucu Hatası',
    notFoundError: 'Kaynak bulunamadı',
    badRequestError: 'Geçersiz istek',
    payloadTooLargeError: 'Dosya Çok Büyük',
    fileTooLargeError: 'Yüklemek istediğiniz dosya çok büyüktür.',
    internalServerError: 'Sunucu iç hatası',
    serviceUnavailableError: 'Hizmet geçici olarak kullanılamıyor',

    // API Error Messages
    apiError: 'API Hatası!',
    requestFailedError: 'İstek başarısız oldu',
    invalidResponseError: 'Sunucudan geçersiz yanıt alındı',
    timeoutError: 'İstek zaman aşımına uğradı',

    // General Error Messages
    operationFailed: 'İşlem başarısız',
    dataLoadError: 'Veri yüklenirken hata oluştu',
    userLoadError: 'Kullanıcı bilgileri yüklenirken hata oluştu',
    saveError: 'Veri kaydedilirken hata oluştu',
    deleteError: 'Veri silinirken hata oluştu',
    updateError: 'Veri güncellenirken hata oluştu',

    // Login Page
    login: 'Giriş',
    signInToYourAccount: 'Hesabınıza giriş yapın',
    username: 'Kullanıcı adı',
    password: 'Şifre',
    welcomeBack: 'Tekrar Hoş Geldiniz!',
    signInToContinue: 'Devam etmek için giriş yapın',
    rememberMe: 'Beni hatırla',
    startYourJourney: 'Fabco',
    loginDescription: 'Güvenli kimlik doğrulama ile panelinize erişin',
    secureAuthentication: 'Güvenli kimlik doğrulama',
    dataProtection: 'Veri koruması',
    '24_7Support': '7/24 Destek',
    signIn: 'GİRİŞ',

    // Form Validations
    usernameRequired: 'Kullanıcı adı boş bırakılamaz.',
    passwordRequired: 'Şifre boş bırakılamaz.',

    // Two Factor Authentication
    twoFactorAuthentication: 'İki Faktörlü Kimlik Doğrulama',
    enter2FACode: '2FA kodunu girin:',
    enter: 'Gir',
    close: 'Kapat',

    balance: 'Bakiye',
    shipments: 'Sevkiyatlar',
    shipmentId: 'Sevkiyat ID',
    opsShipmentStatusGuid: 'Sevkiyat Durum Guid',
    prdUnitGuid: 'Üretim Birim Guid',
    billingCompany: 'Fatura Şirketi',
    shipmentDatetime: 'Sevkiyat Tarihi',
    deliveryNo: 'Teslimat No',
    description: 'Açıklama',
    productShippedQuantity: 'Sevk Edilen Ürün Miktarı',
    netWeight: 'Net Ağırlık',
    grossWeight: 'Brüt Ağırlık',
    opsOrderGuid: 'Sipariş Guid',
    createShipment: 'Sevkiyat Oluştur',
    updateShipment: 'Sevkiyat Güncelle',
    deleteShipment: 'Sevkiyat Sil',
    editShipment: 'Sevkiyat Düzenle',
    shipmentCreated: 'Sevkiyat başarıyla oluşturuldu',
    shipmentUpdated: 'Sevkiyat başarıyla güncellendi',
    shipmentDeleted: 'Sevkiyat başarıyla silindi',
    confirmDeleteShipment: 'Bu sevkiyatı silmek istediğinizden emin misiniz?',
    shipmentDeleteWarning: 'Bu işlem sevkiyat kaydını kalıcı olarak silecek ve geri alınamaz.',
    enterOpsShipmentStatusGuid: 'Sevkiyat durum guid girin',
    enterPrdUnitGuid: 'Üretim birim guid girin',
    enterBillingCompany: 'Fatura şirketi girin',
    enterShipmentDatetime: 'Sevkiyat tarihi girin',
    enterDeliveryNo: 'Teslimat no girin',
    enterDescription: 'Açıklama girin',
    enterProductShippedQuantity: 'Sevk edilen ürün miktarı girin',
    enterOpsOrderGuid: 'Sipariş guid girin',
    opsShipmentStatusGuidRequired: 'Sevkiyat durum guid zorunludur',
    prdUnitGuidRequired: 'Üretim birim guid zorunludur',
    billingCompanyRequired: 'Fatura şirketi zorunludur',
    shipmentDatetimeRequired: 'Sevkiyat tarihi zorunludur',
    deliveryNoRequired: 'Teslimat no zorunludur',
    descriptionRequired: 'Açıklama zorunludur',
    productShippedQuantityRequired: 'Sevk edilen ürün miktarı zorunludur',
    opsOrderGuidRequired: 'Sipariş guid zorunludur',
    stock: 'Stok',
    createStock: 'Stok Oluştur',
    updateStock: 'Stok Güncelle',
    deleteStock: 'Stok Sil',
    editStock: 'Stok Düzenle',
    stockId: 'Stok ID',
    prdUnitGuid: 'Üretim Birim Guid',
    prdUnit: 'Üretim Birimi',
    opsStockStatusGuid: 'Stok Durum Guid',
    opsStockStatus: 'Stok Durumu ',
    productStockQuantity: 'Stok Miktarı',
    stockPlace: 'Stok Yeri',
    lot: 'Lot',
    description: 'Açıklama',
    orderGuid: 'Sipariş Guid',
    orderGuidRequired: 'Sipariş Guid zorunludur',
    prdUnitGuidRequired: 'Üretim Birim Guid zorunludur',
    opsStockStatusGuidRequired: 'Stok Durum Guid zorunludur',
    productStockQuantityRequired: 'Stok Miktarı zorunludur',
    stockPlaceRequired: 'Stok Yeri zorunludur',
    lotRequired: 'Lot zorunludur',
    stockCreated: 'Stok başarıyla oluşturuldu',
    stockUpdated: 'Stok başarıyla güncellendi',
    stockDeleted: 'Stok başarıyla silindi',
    confirmDeleteStock: 'Bu stoğu silmek istediğinizden emin misiniz?',
    days: 'Gün Sayısı',
    stockDeleteWarning: 'Bu işlem stok kaydını kalıcı olarak silecek ve geri alınamaz.',
    // Product
    products: 'Ürünler',
    createProduct: 'Ürün Oluştur',
    updateProduct: 'Ürün Güncelle',
    editProduct: 'Ürünü Düzenle',
    deleteProduct: 'Ürünü Sil',
    confirmDeleteProduct: 'Bu ürünü silmek istediğinizden emin misiniz?',
    productDeleteWarning: 'Bu işlem ürün kaydını kalıcı olarak silecek ve geri alınamaz.',
    weaveCreatedSuccessfully: 'Ürün başarıyla oluşturuldu!',
    productDetails: 'Ürün Detayları',
    productInformation: 'Ürün Bilgileri',
    weaveDetails: 'Dokuma Detayları',
    orderDetails: 'Sipariş Detayları',
    allOrdersForThisProduct: 'Bu ürün için tüm siparişler',
    order: 'Sipariş',
    orderDescription: 'Sipariş Açıklaması',
    note: 'Not',
    notePlaceholder: 'Not girin',
    loadingProductDetails: 'Ürün detayları yükleniyor...',
    errorLoadingProductDetails: 'Ürün detayları yüklenirken hata oluştu',
    productCode: 'Ürün Kodu',
    weaveCode: 'Dokuma Kodu',
    weaveType: 'Örgü Tipi',
    warpYarn: 'Çözgü İpliği',
    weftYarn: 'Atkı İpliği',
    threadName: 'İplik Adı',
    rowNumber: '#',
    threadCompositionName: 'Karışım Adı',
    warpDensity: 'Çözgü Sıklığı',
    weftDensity: 'Atkı Sıklığı',
    reedWidth: 'Tarak Eni',
    reedNo: 'Tarak No',
    dgts: 'DGTS',
    customer: 'Müşteri',
    supplier: 'Tedarikçi',
    unit: 'Birim',
    paymentTerm: 'Ödeme Vadesi',
    enterPaymentTerm: 'Ödeme vadesini girin',
    shipmentPlace: 'Sevk Adresi',
    enterShipmentPlace: 'Sevk adresini girin',
    currency: 'Para Birimi',
    orderStatus: 'Sipariş Durumu',
    orderDate: 'Sipariş Tarihi',
    deadline: 'Termin Tarihi',
    quantity: 'Miktar',
    costPrice: 'Maliyet Fiyatı',
    salesPrice: 'Satış Fiyatı',

    // ProductDetailCard specific translations
    certificate: 'Sertifika',
    lot: 'Lot',
    description: 'Açıklama',
    materialName: 'Materyal Adı',
    weaveTypeName: 'Örgü Tipi',
    warpYarnName: 'Çözgü İpliği Adı',
    weftYarnName: 'Atkı İpliği Adı',
    threadName: 'İplik Adı',
    customerName: 'Müşteri Adı',
    supplierName: 'Tedarikçi Adı',
    unitName: 'Birim Adı',
    currencyName: 'Para Birimi Adı',
    orderDatetime: 'Sipariş Tarihi',
    orderDeadlineDatetime: 'Termin Tarihi',
    productQuantity: 'Ürün Miktarı',
    productCostPrice: 'Ürün Maliyet Fiyatı',
    productSalesPrice: 'Ürün Satış Fiyatı',
    // Product Fields
    prdWeavesGuid: 'Dokuma Guid',
    enterPrdWeavesGuid: 'Dokuma guid girin',
    prdWeavesGuidRequired: 'Dokuma guid zorunludur',
    prdMaterialGuid: 'Materyal Guid',
    enterPrdMaterialGuid: 'Materyal guid girin',
    prdMaterialGuidRequired: 'Materyal zorunludur',
    productCodeForCustomer: 'Ürün Kodu',
    enterProductCodeForCustomer: 'Ürün kodu girin',
    productCodeForCustomerRequired: 'Ürün kodu zorunludur',
    certificate: 'Sertifika',
    enterCertificate: 'Sertifika girin',
    certificateRequired: 'Sertifika zorunludur',
    lot: 'Lot',
    enterLot: 'Lot girin',
    lotRequired: 'Lot zorunludur',

    // Technical Product Fields
    weight: 'Gramaj',
    warpThreadCount: 'Çözgü Tel Adedi',
    enterWarpThreadCount: 'Çözgü tel adedi girin',
    reedNo: 'Tarak No',
    enterReedNo: 'Tarak no girin',
    dgts: 'DGTS',
    enterDGTS: 'DGTS girin',
    enterWarpDensity: 'Çözgü sıklığı girin',
    reedWidth: 'Tarak Eni',
    enterReedWidth: 'Tarak eni girin',
    weftDensity: 'Atkı Sıklığı',
    enterWeftDensity: 'Atkı sıklığı girin',
    weaveCombo: 'Örgü (Combo)',
    enterWeaveCombo: 'Örgü combo girin',
    warpNE: 'Çözgü NE',
    enterWarpNE: 'Çözgü NE girin',
    weftNE: 'Atkı NE',
    enterWeftNE: 'Atkı NE girin',
    warpWeight: 'Çözgü Gramaj',
    enterWarpWeight: 'Çözgü gramaj girin',
    weftWeight: 'Atkı Gramaj',
    enterWeftWeight: 'Atkı gramaj girin',
    totalWeight: 'Toplam Gramaj',
    enterTotalWeight: 'Toplam gramaj girin',
    weaveTypeSelection: 'Dokuma Tipi Seçimi',
    colorReport: 'RENK RAPORU',
    warp: 'Çözgü',
    weft: 'Atkı',
    row: 'Satır',
    column: 'Sütun',
    add: 'Ekle',
    remove: 'Sil',
    colorName: 'Renk Adı',
    colorNumber: 'Renk Numarası',
    yarnName: 'İplik Adı',
    yarnCode: 'İplik Numarası',
    total: 'Toplam',
    action: 'İşlem',
    addRow: 'Satır Ekle',
    addColumn: 'Sütun Ekle',
    removeColumn: 'Sütun Sil',
    removeRow: 'Satırı Sil',
    selectColor: 'Renk Seçin',
    selectYarn: 'İplik Seçin',
    warpColorReport: 'ÇÖZGÜ RENK RAPORU',
    weftColorReport: 'ATKI RENK RAPORU',
    totalLabel: 'TOPLAM:',
    successfullySaved: 'Başarıyla kaydedildi!',

    //Weave Factor
    addFactor: 'Çarpan Ekle',
    firstColumn: 'İlk Sütun',
    secondColumn: 'İkinci Sütun',
    factor: 'Çarpan',
    incomingAmount: 'Gelen Miktar',
    supplierDatetime: 'Tedarikçi Tarihi',
    leftoverYarn: 'Kalan İplik',
    preparedYarn:'İlmar İplik',

    // Order Details Page
    customerCode: 'Müşteri Kodu',
    customerProductCode: 'Müşteri Ürün Kodu',
    orderDetails: 'Sipariş Detayları',
    loadingOrderDetails: 'Sipariş detayları yükleniyor...',
    orderLoadError: 'Sipariş bilgileri yüklenirken bir hata oluştu.',
    orderNotFound: 'Sipariş bulunamadı.',
    apiNotice: 'Not: Detaylı sipariş bilgileri API\'si geliştiriliyor. Şu anda tablodaki temel sipariş verileri gösteriliyor.',
    orderInfo: 'Sipariş Bilgileri',
    productInfo: 'Ürün Bilgileri',
    statusInfo: 'Durum Bilgileri',
    basicInfo: 'Temel Bilgiler',
    dateInfo: 'Tarih Bilgileri',
    quantityAndPrice: 'Miktar ve Fiyat Bilgileri',
    orderId: 'Sipariş ID',
    productCode: 'Ürün Kodu',
    customer: 'Müşteri',
    supplier: 'Tedarikçi',
    unit: 'Birim',
    currency: 'Para Birimi',
    orderDate: 'Sipariş Tarihi',
    deadline: 'Termin Tarihi',
    productionStart: 'Üretim Başlangıcı',
    productionEnd: 'Üretim Bitişi',
    quantity: 'Miktar',
    costPrice: 'Maliyet Fiyatı',
    salesPrice: 'Satış Fiyatı',
    totalPrice: 'Toplam Fiyat',
    dispatchQuantity: 'Sevk Miktarı',
    stockQuantity: 'Stok Miktarı',
    remainingQuantity: 'Kalan Miktar',
    requirementMeter: 'İhtiyaç Miktarı',
    productDetails: 'Ürün Detayları',
    certificateAndLot: 'Sertifika ve Lot Bilgileri',
    productId: 'Ürün ID',
    weaveCode: 'Dokuma Kodu',
    materialName: 'Materyal Adı',
    insertDatetime: 'Oluşturma Tarihi',
    noProductDetailsFound: 'Ürün Detayları Bulunamadı',
    apiNotImplemented: 'Detaylı ürün bilgileri API tam olarak geliştirildiğinde kullanılabilir olacak.',
    orderStatusDetails: 'Sipariş Durum Detayları',
    statusName: 'Durum Adı',
    statusDescription: 'Durum Açıklaması',
    noStatusDetailsFound: 'Durum Detayları Bulunamadı',
    viewDetails: 'Detayları Görüntüle',
    savedSuppliers: 'Kaydedilen Tedarikçiler',
    orderAction: 'Sipariş İşlemi',
    pending: 'Beklemede',
    completed: 'Tamamlandı',
    cancelled: 'İptal Edildi',
    futureDate: 'Gelecek Tarih',
    noProductDetailsDescription: 'Bu sipariş için ürün detayları bulunmuyor.',
    noStatusDetailsDescription: 'Bu sipariş için durum detayları bulunmuyor.',

    // Shipment Information
    shipmentInfo: 'Sevkiyat Bilgileri',
    shipmentDetails: 'Sevkiyat Detayları',
    shipmentCount: 'Toplam',
    shipment: 'Sevkiyat',
    shipmentList: 'Sevkiyat Listesi',
    shipmentCode: 'Sevkiyat Kodu',
    shipmentId: 'Sevkiyat Id',
    shipmentDate: 'Sevkiyat Tarihi',
    deliveryNo: 'Teslimat No',
    billingCompany: 'Fatura Şirketi',
    status: 'Durum',
    unit: 'Birim',
    quantity: 'Miktar',
    description: 'Açıklama',
    noShipmentDetailsFound: 'Sevkiyat Detayları Bulunamadı',
    noShipmentDetailsDescription: 'Bu sipariş için sevkiyat detayları bulunmuyor.',

    // Stock Information
    stockInfo: 'Stok Bilgileri',
    stockDetails: 'Stok Detayları',
    stockCount: 'Toplam',
    stockList: 'Stok Listesi',
    stockId: 'Stok ID',
    stockPlace: 'Stok Yeri',
    lot: 'Lot',
    insertDate: 'Oluşturma Tarihi',
    noStockDetailsFound: 'Stok Detayları Bulunamadı',
    noStockDetailsDescription: 'Bu sipariş için stok detayları bulunmuyor.',

    // Status Badges
    delivered: 'Teslim Edildi',
    inTransit: 'Yolda',
    available: 'Mevcut',
    reserved: 'Rezerve',
    outOfStock: 'Stokta Yok',
    lowStock: 'Düşük Stok',

    // Order Form Labels (without Guid)
    selectCostCurrency: 'Maliyet Para Birimini Seç',
    selectSalesCurrency: 'Satış Para Birimini Seç',
    searchCurrency: 'Para Birimi Ara',
    product: 'Ürün',
    customer: 'Müşteri',
    supplier: 'Tedarikçi',
    unit: 'Birim',
    currency: 'Para Birimi',
    orderStatus: 'Sipariş Durumu',
    orderDatetime: 'Sipariş Tarihi',
    orderDeadlineDatetime: 'Termin Tarihi',
    productQuantity: 'Ürün Miktarı',
    productionStartDatetime: 'Üretim Başlangıç',
    productionEndDatetime: 'Üretim Bitiş',
    productDispatchQuantity: 'Sevk Miktarı',
    productStockQuantity: 'Stok Miktarı',
    productRemainingQuantity: 'Kalan Miktar',
    productCostPrice: 'Maliyet Fiyatı',
    productSalesPrice: 'Satış Fiyatı',
    productTotalPrice: 'Toplam Fiyat',
    select: 'Seçiniz',

    // Order Action Page
    orderAction: 'Sipariş İşlemi',
    orderActionForm: 'Sipariş İşlem Formu',
    orderStatusChange: 'Durum Değişikliği',
    viewDetails: 'Detayları Görüntüle',
    editOrder: 'Siparişi Düzenle',
    deleteOrder: 'Siparişi Sil',
    stockAction: 'Stok İşlemi',
    shipmentAction: 'Sevkiyat İşlemi',
    newOrderStatus: 'Yeni Sipariş Durumu',
    selectStatus: 'Durum Seçin',
    stockUnit: 'Stok Birimi',
    selectUnit: 'Birim Seçin',
    stockStatus: 'Stok Durumu',
    selectStockStatus: 'Stok Durumu Seçin',
    stockQuantity: 'Stok Miktarı',
    rollCount: 'Top Sayısı',
    transferToStock: 'Stoğa Aktarım',
    transferToShipment: 'Sevkiyata Aktarım',
    sourceShipment: 'Kaynak Sevkiyat',
    sourceStock: 'Kaynak Stok',
    targetStock: 'Hedef Stok',
    targetShipment: 'Hedef Sevkiyat',
    selectStock: 'Stok seçiniz',
    selectShipment: 'Sevkiyat seçiniz',
    noStockRecord: 'Uygun stok kaydı bulunamadı',
    noShipmentRecord: 'Uygun sevkiyat kaydı bulunamadı',
    transferQuantity: 'Aktarılacak Miktar',
    transferRollCount: 'Aktarılacak Top Sayısı',
    enterTransferQuantity: 'Aktarılacak miktarı girin',
    enterTransferRollCount: 'Aktarılacak top sayısını girin',
    transferSummary: 'Aktarım Özeti',
    transferRuleHint: 'En az bir alana 0’dan büyük değer girilmelidir.',
    transferDetailsHint: 'Kaynak kaydı ve hedef kaydı kontrol edip aktarılacak değerleri girin.',
    stockRollCount: 'Stok Top Sayısı',
    shipmentRollCount: 'Sevkiyat Top Sayısı',
    enterStockRollCount: 'Stok top sayısını girin',
    enterShipmentRollCount: 'Sevkiyat top sayısını girin',
    enterStockQuantity: 'Stok miktarı girin',
    stockPlace: 'Stok Yeri',
    enterStockPlace: 'Stok yeri girin',
    lot: 'Lot',
    enterLot: 'Lot bilgisi girin',
    stockDescription: 'Stok Açıklaması',
    enterStockDescription: 'Stok açıklaması girin',
    shipmentStatus: 'Sevkiyat Durumu',
    selectShipmentStatus: 'Sevkiyat Durumu Seçin',
    shipmentUnit: 'Sevkiyat Birimi',
    selectShipmentUnit: 'Sevkiyat Birimi Seçin',
    billingCompany: 'Fatura Şirketi',
    enterBillingCompany: 'Fatura şirketi girin',
    shipmentDatetime: 'Sevkiyat Tarihi',
    deliveryNo: 'Teslimat (İrsaliye) Numarası',
    enterDeliveryNo: 'Teslimat numarası girin',
    productShippedQuantity: 'Sevk Edilen Ürün Miktarı',
    enterProductShippedQuantity: 'Sevk edilen ürün miktarı girin',
    shipmentDescription: 'Sevkiyat Açıklaması',
    enterShipmentDescription: 'Sevkiyat açıklaması girin',
    executeAction: 'İşlemi Gerçekleştir',
    processing: 'İşleniyor...',
    orderActionError: 'Sipariş işlemi sırasında bir hata oluştu.',
    orderActionSuccess: 'Sipariş işlemi başarıyla gerçekleştirildi.',
    currentStatus: 'Mevcut Durum',

    // Wizard Interface
    actionSelection: 'İşlem Seçimi',
    selectActionType: 'Hangi işlemleri gerçekleştirmek istediğinizi seçin',
    configureOrderStatus: 'Sipariş durumunu yapılandırın',
    configureStockAction: 'Stok işlemini yapılandırın',
    configureShipmentAction: 'Sevkiyat işlemini yapılandırın',
    reviewAndSubmit: 'Gözden Geçir ve Gönder',
    reviewAllActions: 'Tüm işlemleri gözden geçirin ve gönderin',
    changeOrderStatus: 'Sipariş durumunu değiştirin',
    manageStock: 'Stok işlemlerini yönetin',
    manageShipment: 'Sevkiyat işlemlerini yönetin',
    step: 'Adım',
    next: 'İleri',
    previous: 'Önceki',
    selectedActions: 'Seçilen İşlemler',
    notSet: 'Ayarlanmamış',

    // Validation Messages
    newOrderStatusRequired: 'Yeni sipariş durumu seçilmelidir',
    stockUnitRequired: 'Stok birimi seçilmelidir',
    stockStatusRequired: 'Stok durumu seçilmelidir',
    stockQuantityRequired: 'Stok miktarı girilmelidir',
    stockPlaceRequired: 'Stok yeri girilmelidir',
    lotRequired: 'Lot bilgisi girilmelidir',
    shipmentStatusRequired: 'Sevkiyat durumu seçilmelidir',
    shipmentUnitRequired: 'Sevkiyat birimi seçilmelidir',
    billingCompanyRequired: 'Fatura şirketi girilmelidir',
    shipmentDatetimeRequired: 'Sevkiyat tarihi girilmelidir',
    deliveryNoRequired: 'Teslimat numarası girilmelidir',
    selectAtLeastOneAction: 'En az bir işlem seçilmelidir',
    allStepsCompleted: 'Tüm adımlar tamamlandı. İşlemi gerçekleştirebilirsiniz.',
    stepsIncomplete: 'Tüm adımlar tamamlanmadı. Lütfen eksik bilgileri doldurun.',
    required: 'Zorunlu',
    requiredActions: 'Zorunlu İşlemler',

    // Filtre kontrolleri
    "filters": "Filtreler",
    "clearFilters": "Filtreleri Temizle",
    "search": "Ara",
    "min": "En Az",
    "max": "En Fazla",
    "resultsFound": "sonuç bulundu",
    "totalRecords": "toplam kayıt",
    "noResultsFound": "Arama kriterlerinize uygun sonuç bulunamadı",
    "clearFiltersToSeeAll": "Tüm kayıtları görmek için filtreleri temizleyin",

    // Var olan anahtarların kontrolü (zaten varsa eklemeyin)
    "show": "Göster",
    "entries": "kayıt",
    "Showing": "Gösteriliyor",
    "to": "ile",
    "of": "toplam",
    "loadingData": "Veriler yükleniyor...",
    "noDataFound": "Veri bulunamadı",
    sampleFormats: 'Örnek Formatlar',
    totalWarpWeight: 'Toplam Çözgü Gramaj',
    totalWeftWeight: 'Toplam Atkı Gramaj',

    //Export
    export: 'Aktar',
    chooseExportFormat: 'Aktarma formatını seç',
    exportInfo: 'Aktarma Bilgisi',
    recordsWillBeExported: 'kayıt dışa aktarılacak.',
    exportData: 'Veri Dışa Aktarımı',
    selectExportFormat: 'Dışa aktarma formatını seçin ve verilerinizi indirin:',
    selectExportOptions: 'Dışa aktarma seçeneklerini belirleyin:',
    exportScope: 'Aktarım Kapsamı',
    exportCurrentPage: 'Mevcut Sayfayı Aktar',
    recordsOnThisPage: 'kayıt (bu sayfa)',
    exportAllResults: 'Tüm Sonuçları Aktar',
    totalFilteredRecords: 'toplam kayıt (tüm filtreli sonuçlar)',
    exportFormat: 'Dosya Formatı',
    exportDetails: 'Dışa aktarım detayları:',
    filtersApplied: 'Uygulanan filtreler dahil edilecek',
    actionColumnsExcluded: 'Eylem sütunları hariç tutulacak',
    downloadFile: 'Dosyayı İndir',
    // Export - Önizleme & Yazdırma ekleri
    preview: 'Ön İzleme',
    print: 'Yazdır',
    dataPreview: 'Veri Ön İzleme',
    previewNote: 'Not: Sadece ilk 10 kayıt gösteriliyor. Tüm veriler dışa aktarılacak.',
    scope: 'Kapsam',
    allResults: 'Tüm Sonuçlar',
    currentPage: 'Mevcut Sayfa',
    printDate: 'Yazdırma Tarihi',
    generatedBy: 'Tarafından oluşturuldu',
    pageOf: 'Sayfa',
    records: 'kayıt',
    // Reports
    reports: 'Raporlar',
    customerAgreementReport: 'Müşteri Sözleşmesi',
    caglikReport: 'Çağlık Raporu',
    sampleReport: 'Analiz Raporu',
    sampleReportDescription: 'Analiz seçerek kumaş analiz formunu görüntüleyebilir, yazdırabilir veya Excel formatında indirebilirsiniz.',
    sampleSelection: 'Analiz Seçimi',
    selectSample: 'Analiz Seçin',
    searchSamplePlaceholder: 'Kart no ile ara...',
    selectAgreement: 'Sipariş Seçin',
    selectWeave: 'Tip Kodu Seçin',
    generateReport: 'Raporu Getir',
    agreementSelection: 'Sözleşme Seçimi',
    weaveSelection: 'Tip Kodu Seçimi',
    selectAgreementDescription: 'Sözleşme seçerek raporu görüntüleyebilir, yazdırabilir veya Excel formatında indirebilirsiniz.',
    caglikReportDescription: 'Tip kodu seçerek renk raporlarını görüntüleyebilir, yazdırabilir veya Excel formatında indirebilirsiniz.',
    searchPlaceholder: 'Müşteri kodu, adı veya artikel numarası ile ara...',
    searchWeavePlaceholder: 'Tip Kodu kodu ile ara...',
    reportDetails: 'Rapor Detayları',
    errorLoadingDropdown: 'Dropdown yüklenirken hata oluştu',
    errorLoadingReport: 'Rapor yüklenirken hata oluştu',
    agreementDetails: 'Sözleşme Detayları',
    errorLoadingReport: 'Rapor yüklenirken hata oluştu',
    customerCode: 'Müşteri Kodu',
    required: 'zorunlu',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    // Weave Color Selection
    warp: 'ÇÖZGÜ',
    weft: 'ATKI',
    select: 'Seç',
    position: 'Pozisyon',
    selectedYarn: 'Seçilen İplik',
    weftWeight: 'Atkı Gramaj',
    waftWeight: 'Çözgü Gramaj',
    // Sample fields
    samples: 'Analizler',
    createSample: 'Analiz Oluştur',
    sampleImage: 'Analiz Görseli',
    selectImage: 'Görsel Seç',
    fabricPhoto: 'Kumaş Fotoğrafı',
    armurePhoto: 'Armür Fotoğrafı',
    cardNo: 'Kart No',
    companyName: 'Firma Adı',
    certificate: 'Sertifika (Ürün Sertifikası)',
    date: 'Tarih',
    price: 'Fiyat',
    reedWidth: 'Tarak Eni',
    totalWireCount: 'Toplam Tel Sayısı',
    reedNo: 'Tarak No',
    dgts: 'DGTS',
    warpDensityi: 'Mamül Çözgü Sıklığı',
    weftDensityi: 'Mamül Atkı Sıklığı',
    grayWarp: 'Ham Çözgü Sıklığı',
    grayWeft: 'Ham Atkı Sıklığı',
    // Order Supplier
    orderSuppliers: 'Sipariş Tedarikçileri',
    addSupplier: 'Tedarikçi Ekle',
    unitPrice: 'Birim Fiyat',
    loom: 'Tezgah',
    loomWarpLength: 'Tezgah Çözgü Metresi',
    weavingStartDate: 'Dokuma Başlangıç Tarihi',
    loomDailyProduction: 'Tezgah Günlük Üretim',
    estimatedCompletionTime: 'Tahmini Süre',
    goBack: 'Geri Dön',
    selectSupplierType: 'Tedarikçi Tipi Seçiniz',
    selectSupplierTypeFirst: 'Devam edebilmek için önce Tedarikçi Tipi seçmelisiniz',
    selectSupplier: 'Tedarikçi Seçiniz',
    selectSupplierFirst: 'Devam edebilmek için önce Tedarikçi seçmelisiniz',
    selectCurrency: 'Para Birimi Seçiniz',
    selectWeaveColor: 'Atkı/Çözgü seçiniz',
    noSuppliersYet: 'Henüz tedarikçi eklenmemiş',
    clickAddToStart: 'Tedarikçi eklemek için butona tıklayın',
  },
};
